(function(a) {
    a.fn.prepareTransition = function() {
        return this.each(function() {
            var b = a(this);
            b.one("TransitionEnd webkitTransitionEnd transitionend oTransitionEnd", function() {
                b.removeClass("is-transitioning")
            });
            var c = ["transition-duration", "-moz-transition-duration", "-webkit-transition-duration", "-o-transition-duration"];
            var d = 0;
            a.each(c, function(a, c) {
                d = parseFloat(b.css(c)) || d
            });
            if (d != 0) {
                b.addClass("is-transitioning");
                b[0].offsetWidth
            }
        })
    }
})(jQuery);

function replaceUrlParam(e, r, a) {
    var n = new RegExp("(" + r + "=).*?(&|$)"),
        c = e;
    return c = e.search(n) >= 0 ? e.replace(n, "$1" + a + "$2") : c + (c.indexOf("?") > 0 ? "&" : "?") + r + "=" + a
};
if ((typeof Shopify) === 'undefined') {
    Shopify = {}
}
if (!Shopify.formatMoney) {
    Shopify.formatMoney = function(cents, format) {
        var value = '',
            placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = (format || this.money_format);
        if (typeof cents == 'string') {
            cents = cents.replace('.', '')
        }

        function defaultOption(opt, def) {
            return (typeof opt == 'undefined' ? def : opt)
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2);
            thousands = defaultOption(thousands, ',');
            decimal = defaultOption(decimal, '.');
            if (isNaN(number) || number == null) {
                return 0
            }
            number = (number / 100.0).toFixed(precision);
            var parts = number.split('.'),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                cents = parts[1] ? (decimal + parts[1]) : '';
            return dollars + cents
        }
        switch (formatString.match(placeholderRegex)[1]) {
            case 'amount':
                value = formatWithDelimiters(cents, 2);
                break;
            case 'amount_no_decimals':
                value = formatWithDelimiters(cents, 0);
                break;
            case 'amount_with_comma_separator':
                value = formatWithDelimiters(cents, 2, '.', ',');
                break;
            case 'amount_no_decimals_with_comma_separator':
                value = formatWithDelimiters(cents, 0, '.', ',');
                break
        }
        return formatString.replace(placeholderRegex, value)
    }
}
window.timber = window.timber || {};
timber.cacheSelectors = function() {
    timber.cache = {
        $html: $('html'),
        $body: $(document.body),
        $navigation: $('#AccessibleNav'),
        $mobileSubNavToggle: $('.mobile-nav__toggle'),
        $mobileNavLink: $('.mobile-nav__link'),
        $changeView: $('.change-view'),
        $productImage: $('#ProductPhotoImg'),
        $thumbImages: $('#ProductThumbs').find('a.product-single__thumbnail'),
        $thumbImages2: $('#ProductThumbs2').find('a.product-single__thumbnail'),
        $recoverPasswordLink: $('#RecoverPassword'),
        $hideRecoverPasswordLink: $('#HideRecoverPasswordLink'),
        $recoverPasswordForm: $('#RecoverPasswordForm'),
        $customerLoginForm: $('#CustomerLoginForm'),
        $passwordResetSuccess: $('#ResetSuccess')
    }
};
timber.init = function() {
    FastClick.attach(document.body);
    timber.cacheSelectors();
    timber.accessibleNav();
    timber.drawersInit();
    timber.mobileNavToggle();
    timber.productImageSwitch();
    timber.productImageSwitch2();
    timber.responsiveVideos();
    timber.collectionViews();
    timber.loginForms()
};
timber.accessibleNav = function() {
    var $nav = timber.cache.$navigation,
        $allLinks = $nav.find('a'),
        $topLevel = $nav.children('li').find('a'),
        $parents = $nav.find('.site-nav--has-dropdown'),
        $subMenuLinks = $nav.find('.site-nav__dropdown').find('a'),
        activeClass = 'nav-hover',
        focusClass = 'nav-focus';
    $parents.on('mouseenter touchstart', function(evt) {
        var $el = $(this);
        if (!$el.hasClass(activeClass)) {
            evt.preventDefault()
        }
        showDropdown($el)
    });
    $parents.on('mouseleave', function() {
        hideDropdown($(this))
    });
    $subMenuLinks.on('touchstart', function(evt) {
        evt.stopImmediatePropagation()
    });
    $allLinks.focus(function() {
        handleFocus($(this))
    });
    $allLinks.blur(function() {
        removeFocus($topLevel)
    });

    function handleFocus($el) {
        var $subMenu = $el.next('ul'),
            hasSubMenu = $subMenu.hasClass('sub-nav') ? !0 : !1,
            isSubItem = $('.site-nav__dropdown').has($el).length,
            $newFocus = null;
        if (!isSubItem) {
            removeFocus($topLevel);
            addFocus($el)
        } else {
            $newFocus = $el.closest('.site-nav--has-dropdown').find('a');
            addFocus($newFocus)
        }
    }

    function showDropdown($el) {
        $el.addClass(activeClass);
        setTimeout(function() {
            timber.cache.$body.on('touchstart', function() {
                hideDropdown($el)
            })
        }, 250)
    }

    function hideDropdown($el) {
        $el.removeClass(activeClass);
        timber.cache.$body.off('touchstart')
    }

    function addFocus($el) {
        $el.addClass(focusClass)
    }

    function removeFocus($el) {
        $el.removeClass(focusClass)
    }
};
timber.drawersInit = function() {
    timber.LeftDrawer = new timber.Drawers('NavDrawer', 'left');
    timber.RightDrawer = new timber.Drawers('CartDrawer', 'right', {
        'onDrawerOpen': ajaxCart.load
    })
};
timber.mobileNavToggle = function() {
    timber.cache.$mobileSubNavToggle.on('click', function() {
        $(this).parent().toggleClass('mobile-nav--expanded')
    });
    timber.cache.$mobileNavLink.on('click', function() {
        $(this).parent().toggleClass('mobile-nav--expanded')
    })
};
timber.getHash = function() {
    return window.location.hash
};
timber.productPage = function(options) {
    var moneyFormat = options.money_format,
        variant = options.variant,
        selector = options.selector;
    var $productImage = $('#ProductPhotoImg'),
        $addToCart = $('#AddToCart'),
        $productPrice = $('#ProductPrice'),
        $comparePrice = $('#ComparePrice'),
        $quantityElements = $('.quantity-selector, label + .js-qty'),
        $addToCartText = $('#AddToCartText');
    if (variant) {
        var form = jQuery('#' + selector.domIdPrefix).closest('form');
        for (var i = 0, length = variant.options.length; i < length; i++) {
            var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] + '"]');
//             console.log(radioButton.length)
          if (radioButton.length > 0) {
                radioButton.get(0).checked = !0
            }
            if (variant.compare_at_price > variant.price) {
              var discountElement = document.getElementById('newDiscount');
              if(discountElement) {
                var newDiscount = Math.round((1 - (variant.price / variant.compare_at_price)) * 100);
                newDiscount = '(' + newDiscount + '%)';
                discountElement.textContent = newDiscount;
              }
            }
        }
        if (variant.featured_image) {
            var newImg = variant.featured_image,
                el = $productImage[0];
            Shopify.Image.switchImage(newImg, el, timber.switchImage)
        }
        if (variant.available) {
            $addToCart.removeClass('disabled').prop('disabled', !1);
            $addToCartText.html("Buy Now");
            $quantityElements.show()
        } else {
            $addToCart.addClass('disabled').prop('disabled', !0);
            $addToCartText.html("Sold Out");
            $quantityElements.hide()
            $addToCart.parents("#flower-step").addClass("disabled")
        }
        $productPrice.html(Shopify.formatMoney(variant.price, moneyFormat));
        if (variant.compare_at_price > variant.price) {
            $comparePrice.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat)).show()
        } else {
            $comparePrice.hide()
        }
      
      $("#flower-step").removeClass("disabled")
    } else {
        $addToCart.addClass('disabled').prop('disabled', !0);
        $addToCartText.html("Produk Tidak Tersedia");
        $quantityElements.hide()
        $("#flower-step").addClass("disabled")
    }
    var price1 = parseInt($("#product-price-ori").attr("content"));
    var price2 = parseInt($("#product-price-bundl").attr("content"));
    var price3 = price1 + price2;
    $(".hasil").html(Shopify.formatMoney(price3, moneyFormat))
};
timber.productImageSwitch = function() {
    if (timber.cache.$thumbImages.length) {
        timber.cache.$thumbImages.on('click', function(evt) {
            evt.preventDefault();
            var newImage = $(this).attr('href');
            timber.switchImage(newImage, null, timber.cache.$productImage)
        })
    }
};
timber.productImageSwitch2 = function() {
    if (timber.cache.$thumbImages2.length) {
        timber.cache.$thumbImages2.on('click', function(evt) {
            evt.preventDefault();
            var newImage = $(this).attr('href');
            timber.switchImage(newImage, null, timber.cache.$productImage)
        })
    }
};
timber.switchImage = function(src, imgObject, el) {
    var $el = $(el);
    $el.attr('src', src)
};
timber.responsiveVideos = function() {
    var $iframeVideo = $('iframe[src*="youtube.com/embed"], iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');
    $iframeVideo.each(function() {
        $(this).wrap('<div class="video-wrapper"></div>')
    });
    $iframeReset.each(function() {
        this.src = this.src
    })
};
timber.collectionViews = function() {
    if (timber.cache.$changeView.length) {
        timber.cache.$changeView.on('click', function() {
            var view = $(this).data('view'),
                url = document.URL,
                hasParams = url.indexOf('?') > -1;
            if (hasParams) {
                window.location = replaceUrlParam(url, 'view', view)
            } else {
                window.location = url + '?view=' + view
            }
        })
    }
};
timber.loginForms = function() {
    function showRecoverPasswordForm() {
        timber.cache.$recoverPasswordForm.show();
        timber.cache.$customerLoginForm.hide()
    }

    function hideRecoverPasswordForm() {
        timber.cache.$recoverPasswordForm.hide();
        timber.cache.$customerLoginForm.show()
    }
    timber.cache.$recoverPasswordLink.on('click', function(evt) {
        evt.preventDefault();
        showRecoverPasswordForm()
    });
    timber.cache.$hideRecoverPasswordLink.on('click', function(evt) {
        evt.preventDefault();
        hideRecoverPasswordForm()
    });
    if (timber.getHash() == '#recover') {
        showRecoverPasswordForm()
    }
};
timber.resetPasswordSuccess = function() {
    timber.cache.$passwordResetSuccess.show()
};
timber.Drawers = (function() {
    var Drawer = function(id, position, options) {
        var defaults = {
            close: '.js-drawer-close',
            open: '.js-drawer-open-' + position,
            openClass: 'js-drawer-open',
            dirOpenClass: 'js-drawer-open-' + position
        };
        this.$nodes = {
            parent: $('body, html'),
            page: $('#PageContainer'),
            moved: $('.is-moved-by-drawer')
        };
        this.config = $.extend(defaults, options);
        this.position = position;
        this.$drawer = $('#' + id);
        if (!this.$drawer.length) {
            return !1
        }
        this.drawerIsOpen = !1;
        this.init()
    };
    Drawer.prototype.init = function() {
        $(this.config.open).on('click', $.proxy(this.open, this));
        this.$drawer.find(this.config.close).on('click', $.proxy(this.close, this))
    };
    Drawer.prototype.open = function(evt) {
        var externalCall = !1;
        if (evt) {
            evt.preventDefault()
        } else {
            externalCall = !0
        }
        if (evt && evt.stopPropagation) {
            evt.stopPropagation();
            this.$activeSource = $(evt.currentTarget)
        }
        if (this.drawerIsOpen && !externalCall) {
            return this.close()
        }
        timber.cache.$body.trigger('beforeDrawerOpen.timber', this);
        this.$nodes.moved.addClass('is-transitioning');
        this.$drawer.prepareTransition();
        this.$nodes.parent.addClass(this.config.openClass + ' ' + this.config.dirOpenClass);
        this.drawerIsOpen = !0;
        this.trapFocus(this.$drawer, 'drawer_focus');
        if (this.config.onDrawerOpen && typeof(this.config.onDrawerOpen) == 'function') {
            if (!externalCall) {
                this.config.onDrawerOpen()
            }
        }
        if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
            this.$activeSource.attr('aria-expanded', 'true')
        }
        this.$nodes.page.on('touchmove.drawer', function() {
            return !1
        });
        this.$nodes.page.on('click.drawer', $.proxy(function() {
            this.close();
            return !1
        }, this));
        timber.cache.$body.trigger('afterDrawerOpen.timber', this)
    };
    Drawer.prototype.close = function() {
        if (!this.drawerIsOpen) {
            return
        }
        timber.cache.$body.trigger('beforeDrawerClose.timber', this);
        $(document.activeElement).trigger('blur');
        this.$nodes.moved.prepareTransition({
            disableExisting: !0
        });
        this.$drawer.prepareTransition({
            disableExisting: !0
        });
        this.$nodes.parent.removeClass(this.config.dirOpenClass + ' ' + this.config.openClass);
        this.drawerIsOpen = !1;
        this.removeTrapFocus(this.$drawer, 'drawer_focus');
        this.$nodes.page.off('.drawer');
        timber.cache.$body.trigger('afterDrawerClose.timber', this)
    };
    Drawer.prototype.trapFocus = function($container, eventNamespace) {
        var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';
        $container.attr('tabindex', '-1');
        $container.focus();
        $(document).on(eventName, function(evt) {
            if ($container[0] !== evt.target && !$container.has(evt.target).length) {
                $container.focus()
            }
        })
    };
    Drawer.prototype.removeTrapFocus = function($container, eventNamespace) {
        var eventName = eventNamespace ? 'focusin.' + eventNamespace : 'focusin';
        $container.removeAttr('tabindex');
        $(document).off(eventName)
    };
    return Drawer
})();
$(timber.init);

/*!* @name EasyZoom* @author Matt Hinchliffe <> * @modified    Monday, April 18th, 2016 * @version 2.4.0 */
! function(a) {
    "use strict";

    function b(b, c) {
        this.$target = a(b), this.opts = a.extend({}, i, c, this.$target.data()), void 0 === this.isOpen && this._init()
    }
    var c, d, e, f, g, h, i = {
        loadingNotice: "Loading image",
        errorNotice: "The image could not be loaded",
        errorDuration: 2500,
        linkAttribute: "href",
        preventClicks: !0,
        beforeShow: a.noop,
        beforeHide: a.noop,
        onShow: a.noop,
        onHide: a.noop,
        onMove: a.noop
    };
    b.prototype._init = function() {
        this.$link = this.$target.find("a"), this.$image = this.$target.find("img"), this.$flyout = a('<div class="easyzoom-flyout" />'), this.$notice = a('<div class="easyzoom-notice" />'), this.$target.on({
            "mousemove.easyzoom touchmove.easyzoom": a.proxy(this._onMove, this),
            "mouseleave.easyzoom touchend.easyzoom": a.proxy(this._onLeave, this),
            "mouseenter.easyzoom touchstart.easyzoom": a.proxy(this._onEnter, this)
        }), this.opts.preventClicks && this.$target.on("click.easyzoom", function(a) {
            a.preventDefault()
        })
    }, b.prototype.show = function(a, b) {
        var g, h, i, j, k = this;
        if (this.opts.beforeShow.call(this) !== !1) {
            if (!this.isReady) return this._loadImage(this.$link.attr(this.opts.linkAttribute), function() {
                (k.isMouseOver || !b) && k.show(a)
            });
            this.$target.append(this.$flyout), g = this.$target.width(), h = this.$target.height(), i = this.$flyout.width(), j = this.$flyout.height(), c = this.$zoom.width() - i, d = this.$zoom.height() - j, e = c / g, f = d / h, this.isOpen = !0, this.opts.onShow.call(this), a && this._move(a)
        }
    }, b.prototype._onEnter = function(a) {
        var b = a.originalEvent.touches;
        this.isMouseOver = !0, b && 1 != b.length || (a.preventDefault(), this.show(a, !0))
    }, b.prototype._onMove = function(a) {
        this.isOpen && (a.preventDefault(), this._move(a))
    }, b.prototype._onLeave = function() {
        this.isMouseOver = !1, this.isOpen && this.hide()
    }, b.prototype._onLoad = function(a) {
        a.currentTarget.width && (this.isReady = !0, this.$notice.detach(), this.$flyout.html(this.$zoom), this.$target.removeClass("is-loading").addClass("is-ready"), a.data.call && a.data())
    }, b.prototype._onError = function() {
        var a = this;
        this.$notice.text(this.opts.errorNotice), this.$target.removeClass("is-loading").addClass("is-error"), this.detachNotice = setTimeout(function() {
            a.$notice.detach(), a.detachNotice = null
        }, this.opts.errorDuration)
    }, b.prototype._loadImage = function(b, c) {
        var d = new Image;
        this.$target.addClass("is-loading").append(this.$notice.text(this.opts.loadingNotice)), this.$zoom = a(d).on("error", a.proxy(this._onError, this)).on("load", c, a.proxy(this._onLoad, this)), d.style.position = "absolute", d.src = b
    }, b.prototype._move = function(a) {
        if (0 === a.type.indexOf("touch")) {
            var b = a.touches || a.originalEvent.touches;
            g = b[0].pageX, h = b[0].pageY
        } else g = a.pageX || g, h = a.pageY || h;
        var i = this.$target.offset(),
            j = h - i.top,
            k = g - i.left,
            l = Math.ceil(j * f),
            m = Math.ceil(k * e);
        if (0 > m || 0 > l || m > c || l > d) this.hide();
        else {
            var n = -1 * l,
                o = -1 * m;
            this.$zoom.css({
                top: n,
                left: o
            }), this.opts.onMove.call(this, n, o)
        }
    }, b.prototype.hide = function() {
        this.isOpen && this.opts.beforeHide.call(this) !== !1 && (this.$flyout.detach(), this.isOpen = !1, this.opts.onHide.call(this))
    }, b.prototype.swap = function(b, c, d) {
        this.hide(), this.isReady = !1, this.detachNotice && clearTimeout(this.detachNotice), this.$notice.parent().length && this.$notice.detach(), this.$target.removeClass("is-loading is-ready is-error"), this.$image.attr({
            src: b,
            srcset: a.isArray(d) ? d.join() : d
        }), this.$link.attr(this.opts.linkAttribute, c)
    }, b.prototype.teardown = function() {
        this.hide(), this.$target.off(".easyzoom").removeClass("is-loading is-ready is-error"), this.detachNotice && clearTimeout(this.detachNotice), delete this.$link, delete this.$zoom, delete this.$image, delete this.$notice, delete this.$flyout, delete this.isOpen, delete this.isReady
    }, a.fn.easyZoom = function(c) {
        return this.each(function() {
            var d = a.data(this, "easyZoom");
            d ? void 0 === d.isOpen && d._init() : a.data(this, "easyZoom", new b(this, c))
        })
    }, "function" == typeof define && define.amd ? define(function() {
        return b
    }) : "undefined" != typeof module && module.exports && (module.exports = b)
}(jQuery);

if (!jQuery) throw new Error("Bootstrap requires jQuery"); + function(t) {
    "use strict";

    function e() {
        var t = document.createElement("bootstrap"),
            e = {
                WebkitTransition: "webkitTransitionEnd",
                MozTransition: "transitionend",
                OTransition: "oTransitionEnd otransitionend",
                transition: "transitionend"
            };
        for (var n in e)
            if (void 0 !== t.style[n]) return {
                end: e[n]
            }
    }
    t.fn.emulateTransitionEnd = function(e) {
        var n = !1,
            i = this;
        t(this).one(t.support.transition.end, function() {
            n = !0
        });
        var o = function() {
            n || t(i).trigger(t.support.transition.end)
        };
        return setTimeout(o, e), this
    }, t(function() {
        t.support.transition = e()
    })
}(window.jQuery),
function(t) {
    "use strict";
    var e = '[data-dismiss="alert"]',
        n = function(n) {
            t(n).on("click", e, this.close)
        };
    n.prototype.close = function(e) {
        function n() {
            s.trigger("closed.bs.alert").remove()
        }
        var i = t(this),
            o = i.attr("data-target");
        o || (o = i.attr("href"), o = o && o.replace(/.*(?=#[^\s]*$)/, ""));
        var s = t(o);
        e && e.preventDefault(), s.length || (s = i.hasClass("alert") ? i : i.parent()), s.trigger(e = t.Event("close.bs.alert")), e.isDefaultPrevented() || (s.removeClass("in"), t.support.transition && s.hasClass("fade") ? s.one(t.support.transition.end, n).emulateTransitionEnd(150) : n())
    };
    var i = t.fn.alert;
    t.fn.alert = function(e) {
        return this.each(function() {
            var i = t(this),
                o = i.data("bs.alert");
            o || i.data("bs.alert", o = new n(this)), "string" == typeof e && o[e].call(i)
        })
    }, t.fn.alert.Constructor = n, t.fn.alert.noConflict = function() {
        return t.fn.alert = i, this
    }, t(document).on("click.bs.alert.data-api", e, n.prototype.close)
}(window.jQuery),
function(t) {
    "use strict";
    var e = function(n, i) {
        this.$element = t(n), this.options = t.extend({}, e.DEFAULTS, i)
    };
    e.DEFAULTS = {
        loadingText: "loading..."
    }, e.prototype.setState = function(t) {
        var e = "disabled",
            n = this.$element,
            i = n.is("input") ? "val" : "html",
            o = n.data();
        t += "Text", o.resetText || n.data("resetText", n[i]()), n[i](o[t] || this.options[t]), setTimeout(function() {
            "loadingText" == t ? n.addClass(e).attr(e, e) : n.removeClass(e).removeAttr(e)
        }, 0)
    }, e.prototype.toggle = function() {
        var t = this.$element.closest('[data-toggle="buttons"]');
        if (t.length) {
            "radio" === this.$element.find("input").prop("checked", !this.$element.hasClass("active")).trigger("change").prop("type") && t.find(".active").removeClass("active")
        }
        this.$element.toggleClass("active")
    };
    var n = t.fn.button;
    t.fn.button = function(n) {
        return this.each(function() {
            var i = t(this),
                o = i.data("bs.button"),
                s = "object" == typeof n && n;
            o || i.data("bs.button", o = new e(this, s)), "toggle" == n ? o.toggle() : n && o.setState(n)
        })
    }, t.fn.button.Constructor = e, t.fn.button.noConflict = function() {
        return t.fn.button = n, this
    }, t(document).on("click.bs.button.data-api", "[data-toggle^=button]", function(e) {
        var n = t(e.target);
        n.hasClass("btn") || (n = n.closest(".btn")), n.button("toggle"), e.preventDefault()
    })
}(window.jQuery),
function(t) {
    "use strict";
    var e = function(e, n) {
        this.$element = t(e), this.$indicators = this.$element.find(".carousel-indicators"), this.options = n, this.paused = this.sliding = this.interval = this.$active = this.$items = null, "hover" == this.options.pause && this.$element.on("mouseenter", t.proxy(this.pause, this)).on("mouseleave", t.proxy(this.cycle, this))
    };
    e.DEFAULTS = {
        interval: 5e3,
        pause: "hover",
        wrap: !0
    }, e.prototype.cycle = function(e) {
        return e || (this.paused = !1), this.interval && clearInterval(this.interval), this.options.interval && !this.paused && (this.interval = setInterval(t.proxy(this.next, this), this.options.interval)), this
    }, e.prototype.getActiveIndex = function() {
        return this.$active = this.$element.find(".item.active"), this.$items = this.$active.parent().children(), this.$items.index(this.$active)
    }, e.prototype.to = function(e) {
        var n = this,
            i = this.getActiveIndex();
        return e > this.$items.length - 1 || 0 > e ? void 0 : this.sliding ? this.$element.one("slid", function() {
            n.to(e)
        }) : i == e ? this.pause().cycle() : this.slide(e > i ? "next" : "prev", t(this.$items[e]))
    }, e.prototype.pause = function(e) {
        return e || (this.paused = !0), this.$element.find(".next, .prev").length && t.support.transition.end && (this.$element.trigger(t.support.transition.end), this.cycle(!0)), this.interval = clearInterval(this.interval), this
    }, e.prototype.next = function() {
        return this.sliding ? void 0 : this.slide("next")
    }, e.prototype.prev = function() {
        return this.sliding ? void 0 : this.slide("prev")
    }, e.prototype.slide = function(e, n) {
        var i = this.$element.find(".item.active"),
            o = n || i[e](),
            s = this.interval,
            r = "next" == e ? "left" : "right",
            a = "next" == e ? "first" : "last",
            l = this;
        if (!o.length) {
            if (!this.options.wrap) return;
            o = this.$element.find(".item")[a]()
        }
        this.sliding = !0, s && this.pause();
        var c = t.Event("slide.bs.carousel", {
            relatedTarget: o[0],
            direction: r
        });
        if (!o.hasClass("active")) {
            if (this.$indicators.length && (this.$indicators.find(".active").removeClass("active"), this.$element.one("slid", function() {
                    var e = t(l.$indicators.children()[l.getActiveIndex()]);
                    e && e.addClass("active")
                })), t.support.transition && this.$element.hasClass("slide")) {
                if (this.$element.trigger(c), c.isDefaultPrevented()) return;
                o.addClass(e), o[0].offsetWidth, i.addClass(r), o.addClass(r), i.one(t.support.transition.end, function() {
                    o.removeClass([e, r].join(" ")).addClass("active"), i.removeClass(["active", r].join(" ")), l.sliding = !1, setTimeout(function() {
                        l.$element.trigger("slid")
                    }, 0)
                }).emulateTransitionEnd(600)
            } else {
                if (this.$element.trigger(c), c.isDefaultPrevented()) return;
                i.removeClass("active"), o.addClass("active"), this.sliding = !1, this.$element.trigger("slid")
            }
            return s && this.cycle(), this
        }
    };
    var n = t.fn.carousel;
    t.fn.carousel = function(n) {
        return this.each(function() {
            var i = t(this),
                o = i.data("bs.carousel"),
                s = t.extend({}, e.DEFAULTS, i.data(), "object" == typeof n && n),
                r = "string" == typeof n ? n : s.slide;
            o || i.data("bs.carousel", o = new e(this, s)), "number" == typeof n ? o.to(n) : r ? o[r]() : s.interval && o.pause().cycle()
        })
    }, t.fn.carousel.Constructor = e, t.fn.carousel.noConflict = function() {
        return t.fn.carousel = n, this
    }, t(document).on("click.bs.carousel.data-api", "[data-slide], [data-slide-to]", function(e) {
        var n, i = t(this),
            o = t(i.attr("data-target") || (n = i.attr("href")) && n.replace(/.*(?=#[^\s]+$)/, "")),
            s = t.extend({}, o.data(), i.data()),
            r = i.attr("data-slide-to");
        r && (s.interval = !1), o.carousel(s), (r = i.attr("data-slide-to")) && o.data("bs.carousel").to(r), e.preventDefault()
    }), t(window).on("load", function() {
        t('[data-ride="carousel"]').each(function() {
            var e = t(this);
            e.carousel(e.data())
        })
    })
}(window.jQuery),
function(t) {
    "use strict";
    var e = function(n, i) {
        this.$element = t(n), this.options = t.extend({}, e.DEFAULTS, i), this.transitioning = null, this.options.parent && (this.$parent = t(this.options.parent)), this.options.toggle && this.toggle()
    };
    e.DEFAULTS = {
        toggle: !0
    }, e.prototype.dimension = function() {
        return this.$element.hasClass("width") ? "width" : "height"
    }, e.prototype.show = function() {
        if (!this.transitioning && !this.$element.hasClass("in")) {
            var e = t.Event("show.bs.collapse");
            if (this.$element.trigger(e), !e.isDefaultPrevented()) {
                var n = this.$parent && this.$parent.find("> .panel > .in");
                if (n && n.length) {
                    var i = n.data("bs.collapse");
                    if (i && i.transitioning) return;
                    n.collapse("hide"), i || n.data("bs.collapse", null)
                }
                var o = this.dimension();
                this.$element.removeClass("collapse").addClass("collapsing")[o](0), this.transitioning = 1;
                var s = function() {
                    this.$element.removeClass("collapsing").addClass("in")[o]("auto"), this.transitioning = 0, this.$element.trigger("shown.bs.collapse")
                };
                if (!t.support.transition) return s.call(this);
                var r = t.camelCase(["scroll", o].join("-"));
                this.$element.one(t.support.transition.end, t.proxy(s, this)).emulateTransitionEnd(350)[o](this.$element[0][r])
            }
        }
    }, e.prototype.hide = function() {
        if (!this.transitioning && this.$element.hasClass("in")) {
            var e = t.Event("hide.bs.collapse");
            if (this.$element.trigger(e), !e.isDefaultPrevented()) {
                var n = this.dimension();
                this.$element[n](this.$element[n]())[0].offsetHeight, this.$element.addClass("collapsing").removeClass("collapse").removeClass("in"), this.transitioning = 1;
                var i = function() {
                    this.transitioning = 0, this.$element.trigger("hidden.bs.collapse").removeClass("collapsing").addClass("collapse")
                };
                return t.support.transition ? void this.$element[n](0).one(t.support.transition.end, t.proxy(i, this)).emulateTransitionEnd(350) : i.call(this)
            }
        }
    }, e.prototype.toggle = function() {
        this[this.$element.hasClass("in") ? "hide" : "show"]()
    };
    var n = t.fn.collapse;
    t.fn.collapse = function(n) {
        return this.each(function() {
            var i = t(this),
                o = i.data("bs.collapse"),
                s = t.extend({}, e.DEFAULTS, i.data(), "object" == typeof n && n);
            o || i.data("bs.collapse", o = new e(this, s)), "string" == typeof n && o[n]()
        })
    }, t.fn.collapse.Constructor = e, t.fn.collapse.noConflict = function() {
        return t.fn.collapse = n, this
    }, t(document).on("click.bs.collapse.data-api", "[data-toggle=collapse]", function(e) {
        var n, i = t(this),
            o = i.attr("data-target") || e.preventDefault() || (n = i.attr("href")) && n.replace(/.*(?=#[^\s]+$)/, ""),
            s = t(o),
            r = s.data("bs.collapse"),
            a = r ? "toggle" : i.data(),
            l = i.attr("data-parent"),
            c = l && t(l);
        r && r.transitioning || (c && c.find('[data-toggle=collapse][data-parent="' + l + '"]').not(i).addClass("collapsed"), i[s.hasClass("in") ? "addClass" : "removeClass"]("collapsed")), s.collapse(a)
    })
}(window.jQuery),
function(t) {
    "use strict";

    function e() {
        t(i).remove(), t(o).each(function(e) {
            var i = n(t(this));
            i.hasClass("open") && (i.trigger(e = t.Event("hide.bs.dropdown")), e.isDefaultPrevented() || i.removeClass("open").trigger("hidden.bs.dropdown"))
        })
    }

    function n(e) {
        var n = e.attr("data-target");
        n || (n = e.attr("href"), n = n && /#/.test(n) && n.replace(/.*(?=#[^\s]*$)/, ""));
        var i = n && t(n);
        return i && i.length ? i : e.parent()
    }
    var i = ".dropdown-backdrop",
        o = "[data-toggle=dropdown]",
        s = function(e) {
            t(e).on("click.bs.dropdown", this.toggle)
        };
    s.prototype.toggle = function(i) {
        var o = t(this);
        if (!o.is(".disabled, :disabled")) {
            var s = n(o),
                r = s.hasClass("open");
            if (e(), !r) {
                if ("ontouchstart" in document.documentElement && !s.closest(".navbar-nav").length && t('<div class="dropdown-backdrop"/>').insertAfter(t(this)).on("click", e), s.trigger(i = t.Event("show.bs.dropdown")), i.isDefaultPrevented()) return;
                s.toggleClass("open").trigger("shown.bs.dropdown"), o.focus()
            }
            return !1
        }
    }, s.prototype.keydown = function(e) {
        if (/(38|40|27)/.test(e.keyCode)) {
            var i = t(this);
            if (e.preventDefault(), e.stopPropagation(), !i.is(".disabled, :disabled")) {
                var s = n(i),
                    r = s.hasClass("open");
                if (!r || r && 27 == e.keyCode) return 27 == e.which && s.find(o).focus(), i.click();
                var a = t("[role=menu] li:not(.divider):visible a", s);
                if (a.length) {
                    var l = a.index(a.filter(":focus"));
                    38 == e.keyCode && l > 0 && l--, 40 == e.keyCode && l < a.length - 1 && l++, ~l || (l = 0), a.eq(l).focus()
                }
            }
        }
    };
    var r = t.fn.dropdown;
    t.fn.dropdown = function(e) {
        return this.each(function() {
            var n = t(this),
                i = n.data("dropdown");
            i || n.data("dropdown", i = new s(this)), "string" == typeof e && i[e].call(n)
        })
    }, t.fn.dropdown.Constructor = s, t.fn.dropdown.noConflict = function() {
        return t.fn.dropdown = r, this
    }, t(document).on("click.bs.dropdown.data-api", e).on("click.bs.dropdown.data-api", ".dropdown form", function(t) {
        t.stopPropagation()
    }).on("click.bs.dropdown.data-api", o, s.prototype.toggle).on("keydown.bs.dropdown.data-api", o + ", [role=menu]", s.prototype.keydown)
}(window.jQuery),
function(t) {
    "use strict";
    var e = function(e, n) {
        this.options = n, this.$element = t(e), this.$backdrop = this.isShown = null, this.options.remote && this.$element.load(this.options.remote)
    };
    e.DEFAULTS = {
        backdrop: !0,
        keyboard: !0,
        show: !0
    }, e.prototype.toggle = function(t) {
        return this[this.isShown ? "hide" : "show"](t)
    }, e.prototype.show = function(e) {
        var n = this,
            i = t.Event("show.bs.modal", {
                relatedTarget: e
            });
        this.$element.trigger(i), this.isShown || i.isDefaultPrevented() || (this.isShown = !0, this.escape(), this.$element.on("click.dismiss.modal", '[data-dismiss="modal"]', t.proxy(this.hide, this)), this.backdrop(function() {
            var i = t.support.transition && n.$element.hasClass("fade");
            n.$element.parent().length || n.$element.appendTo(document.body), n.$element.show(), i && n.$element[0].offsetWidth, n.$element.addClass("in").attr("aria-hidden", !1), n.enforceFocus();
            var o = t.Event("shown.bs.modal", {
                relatedTarget: e
            });
            i ? n.$element.find(".modal-dialog").one(t.support.transition.end, function() {
                n.$element.focus().trigger(o)
            }).emulateTransitionEnd(300) : n.$element.focus().trigger(o)
        }))
    }, e.prototype.hide = function(e) {
        e && e.preventDefault(), e = t.Event("hide.bs.modal"), this.$element.trigger(e), this.isShown && !e.isDefaultPrevented() && (this.isShown = !1, this.escape(), t(document).off("focusin.bs.modal"), this.$element.removeClass("in").attr("aria-hidden", !0).off("click.dismiss.modal"), t.support.transition && this.$element.hasClass("fade") ? this.$element.one(t.support.transition.end, t.proxy(this.hideModal, this)).emulateTransitionEnd(300) : this.hideModal())
    }, e.prototype.enforceFocus = function() {
        t(document).off("focusin.bs.modal").on("focusin.bs.modal", t.proxy(function(t) {
            this.$element[0] === t.target || this.$element.has(t.target).length || this.$element.focus()
        }, this))
    }, e.prototype.escape = function() {
        this.isShown && this.options.keyboard ? this.$element.on("keyup.dismiss.bs.modal", t.proxy(function(t) {
            27 == t.which && this.hide()
        }, this)) : this.isShown || this.$element.off("keyup.dismiss.bs.modal")
    }, e.prototype.hideModal = function() {
        var t = this;
        this.$element.hide(), this.backdrop(function() {
            t.removeBackdrop(), t.$element.trigger("hidden.bs.modal")
        })
    }, e.prototype.removeBackdrop = function() {
        this.$backdrop && this.$backdrop.remove(), this.$backdrop = null
    }, e.prototype.backdrop = function(e) {
        var n = this.$element.hasClass("fade") ? "fade" : "";
        if (this.isShown && this.options.backdrop) {
            var i = t.support.transition && n;
            if (this.$backdrop = t('<div class="modal-backdrop ' + n + '" />').appendTo(document.body), this.$element.on("click.dismiss.modal", t.proxy(function(t) {
                    t.target === t.currentTarget && ("static" == this.options.backdrop ? this.$element[0].focus.call(this.$element[0]) : this.hide.call(this))
                }, this)), i && this.$backdrop[0].offsetWidth, this.$backdrop.addClass("in"), !e) return;
            i ? this.$backdrop.one(t.support.transition.end, e).emulateTransitionEnd(150) : e()
        } else !this.isShown && this.$backdrop ? (this.$backdrop.removeClass("in"), t.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one(t.support.transition.end, e).emulateTransitionEnd(150) : e()) : e && e()
    };
    var n = t.fn.modal;
    t.fn.modal = function(n, i) {
        return this.each(function() {
            var o = t(this),
                s = o.data("bs.modal"),
                r = t.extend({}, e.DEFAULTS, o.data(), "object" == typeof n && n);
            s || o.data("bs.modal", s = new e(this, r)), "string" == typeof n ? s[n](i) : r.show && s.show(i)
        })
    }, t.fn.modal.Constructor = e, t.fn.modal.noConflict = function() {
        return t.fn.modal = n, this
    }, t(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function(e) {
        var n = t(this),
            i = n.attr("href"),
            o = t(n.attr("data-target") || i && i.replace(/.*(?=#[^\s]+$)/, "")),
            s = o.data("modal") ? "toggle" : t.extend({
                remote: !/#/.test(i) && i
            }, o.data(), n.data());
        e.preventDefault(), o.modal(s, this).one("hide", function() {
            n.is(":visible") && n.focus()
        })
    }), t(document).on("show.bs.modal", ".modal", function() {
        t(document.body).addClass("modal-open")
    }).on("hidden.bs.modal", ".modal", function() {
        t(document.body).removeClass("modal-open")
    })
}(window.jQuery),
function(t) {
    "use strict";
    var e = function(t, e) {
        this.type = this.options = this.enabled = this.timeout = this.hoverState = this.$element = null, this.init("tooltip", t, e)
    };
    e.DEFAULTS = {
        animation: !0,
        placement: "top",
        selector: !1,
        template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: "hover focus",
        title: "",
        delay: 0,
        html: !1,
        container: !1
    }, e.prototype.init = function(e, n, i) {
        this.enabled = !0, this.type = e, this.$element = t(n), this.options = this.getOptions(i);
        for (var o = this.options.trigger.split(" "), s = o.length; s--;) {
            var r = o[s];
            if ("click" == r) this.$element.on("click." + this.type, this.options.selector, t.proxy(this.toggle, this));
            else if ("manual" != r) {
                var a = "hover" == r ? "mouseenter" : "focus",
                    l = "hover" == r ? "mouseleave" : "blur";
                this.$element.on(a + "." + this.type, this.options.selector, t.proxy(this.enter, this)), this.$element.on(l + "." + this.type, this.options.selector, t.proxy(this.leave, this))
            }
        }
        this.options.selector ? this._options = t.extend({}, this.options, {
            trigger: "manual",
            selector: ""
        }) : this.fixTitle()
    }, e.prototype.getDefaults = function() {
        return e.DEFAULTS
    }, e.prototype.getOptions = function(e) {
        return e = t.extend({}, this.getDefaults(), this.$element.data(), e), e.delay && "number" == typeof e.delay && (e.delay = {
            show: e.delay,
            hide: e.delay
        }), e
    }, e.prototype.getDelegateOptions = function() {
        var e = {},
            n = this.getDefaults();
        return this._options && t.each(this._options, function(t, i) {
            n[t] != i && (e[t] = i)
        }), e
    }, e.prototype.enter = function(e) {
        var n = e instanceof this.constructor ? e : t(e.currentTarget)[this.type](this.getDelegateOptions()).data("bs." + this.type);
        return clearTimeout(n.timeout), n.hoverState = "in", n.options.delay && n.options.delay.show ? void(n.timeout = setTimeout(function() {
            "in" == n.hoverState && n.show()
        }, n.options.delay.show)) : n.show()
    }, e.prototype.leave = function(e) {
        var n = e instanceof this.constructor ? e : t(e.currentTarget)[this.type](this.getDelegateOptions()).data("bs." + this.type);
        return clearTimeout(n.timeout), n.hoverState = "out", n.options.delay && n.options.delay.hide ? void(n.timeout = setTimeout(function() {
            "out" == n.hoverState && n.hide()
        }, n.options.delay.hide)) : n.hide()
    }, e.prototype.show = function() {
        var e = t.Event("show.bs." + this.type);
        if (this.hasContent() && this.enabled) {
            if (this.$element.trigger(e), e.isDefaultPrevented()) return;
            var n = this.tip();
            this.setContent(), this.options.animation && n.addClass("fade");
            var i = "function" == typeof this.options.placement ? this.options.placement.call(this, n[0], this.$element[0]) : this.options.placement,
                o = /\s?auto?\s?/i,
                s = o.test(i);
            s && (i = i.replace(o, "") || "top"), n.detach().css({
                top: 0,
                left: 0,
                display: "block"
            }).addClass(i), this.options.container ? n.appendTo(this.options.container) : n.insertAfter(this.$element);
            var r = this.getPosition(),
                a = n[0].offsetWidth,
                l = n[0].offsetHeight;
            if (s) {
                var c = this.$element.parent(),
                    d = i,
                    u = document.documentElement.scrollTop || document.body.scrollTop,
                    p = "body" == this.options.container ? window.innerWidth : c.outerWidth(),
                    h = "body" == this.options.container ? window.innerHeight : c.outerHeight(),
                    f = "body" == this.options.container ? 0 : c.offset().left;
                i = "bottom" == i && r.top + r.height + l - u > h ? "top" : "top" == i && r.top - u - l < 0 ? "bottom" : "right" == i && r.right + a > p ? "left" : "left" == i && r.left - a < f ? "right" : i, n.removeClass(d).addClass(i)
            }
            var g = this.getCalculatedOffset(i, r, a, l);
            this.applyPlacement(g, i), this.$element.trigger("shown.bs." + this.type)
        }
    }, e.prototype.applyPlacement = function(t, e) {
        var n, i = this.tip(),
            o = i[0].offsetWidth,
            s = i[0].offsetHeight,
            r = parseInt(i.css("margin-top"), 10),
            a = parseInt(i.css("margin-left"), 10);
        isNaN(r) && (r = 0), isNaN(a) && (a = 0), t.top = t.top + r, t.left = t.left + a, i.offset(t).addClass("in");
        var l = i[0].offsetWidth,
            c = i[0].offsetHeight;
        if ("top" == e && c != s && (n = !0, t.top = t.top + s - c), /bottom|top/.test(e)) {
            var d = 0;
            t.left < 0 && (d = -2 * t.left, t.left = 0, i.offset(t), l = i[0].offsetWidth, c = i[0].offsetHeight), this.replaceArrow(d - o + l, l, "left")
        } else this.replaceArrow(c - s, c, "top");
        n && i.offset(t)
    }, e.prototype.replaceArrow = function(t, e, n) {
        this.arrow().css(n, t ? 50 * (1 - t / e) + "%" : "")
    }, e.prototype.setContent = function() {
        var t = this.tip(),
            e = this.getTitle();
        t.find(".tooltip-inner")[this.options.html ? "html" : "text"](e), t.removeClass("fade in top bottom left right")
    }, e.prototype.hide = function() {
        function e() {
            "in" != n.hoverState && i.detach()
        }
        var n = this,
            i = this.tip(),
            o = t.Event("hide.bs." + this.type);
        return this.$element.trigger(o), o.isDefaultPrevented() ? void 0 : (i.removeClass("in"), t.support.transition && this.$tip.hasClass("fade") ? i.one(t.support.transition.end, e).emulateTransitionEnd(150) : e(), this.$element.trigger("hidden.bs." + this.type), this)
    }, e.prototype.fixTitle = function() {
        var t = this.$element;
        (t.attr("title") || "string" != typeof t.attr("data-original-title")) && t.attr("data-original-title", t.attr("title") || "").attr("title", "")
    }, e.prototype.hasContent = function() {
        return this.getTitle()
    }, e.prototype.getPosition = function() {
        var e = this.$element[0];
        return t.extend({}, "function" == typeof e.getBoundingClientRect ? e.getBoundingClientRect() : {
            width: e.offsetWidth,
            height: e.offsetHeight
        }, this.$element.offset())
    }, e.prototype.getCalculatedOffset = function(t, e, n, i) {
        return "bottom" == t ? {
            top: e.top + e.height,
            left: e.left + e.width / 2 - n / 2
        } : "top" == t ? {
            top: e.top - i,
            left: e.left + e.width / 2 - n / 2
        } : "left" == t ? {
            top: e.top + e.height / 2 - i / 2,
            left: e.left - n
        } : {
            top: e.top + e.height / 2 - i / 2,
            left: e.left + e.width
        }
    }, e.prototype.getTitle = function() {
        var t = this.$element,
            e = this.options;
        return t.attr("data-original-title") || ("function" == typeof e.title ? e.title.call(t[0]) : e.title)
    }, e.prototype.tip = function() {
        return this.$tip = this.$tip || t(this.options.template)
    }, e.prototype.arrow = function() {
        return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow")
    }, e.prototype.validate = function() {
        this.$element[0].parentNode || (this.hide(), this.$element = null, this.options = null)
    }, e.prototype.enable = function() {
        this.enabled = !0
    }, e.prototype.disable = function() {
        this.enabled = !1
    }, e.prototype.toggleEnabled = function() {
        this.enabled = !this.enabled
    }, e.prototype.toggle = function(e) {
        var n = e ? t(e.currentTarget)[this.type](this.getDelegateOptions()).data("bs." + this.type) : this;
        n.tip().hasClass("in") ? n.leave(n) : n.enter(n)
    }, e.prototype.destroy = function() {
        this.hide().$element.off("." + this.type).removeData("bs." + this.type)
    };
    var n = t.fn.tooltip;
    t.fn.tooltip = function(n) {
        return this.each(function() {
            var i = t(this),
                o = i.data("bs.tooltip"),
                s = "object" == typeof n && n;
            o || i.data("bs.tooltip", o = new e(this, s)), "string" == typeof n && o[n]()
        })
    }, t.fn.tooltip.Constructor = e, t.fn.tooltip.noConflict = function() {
        return t.fn.tooltip = n, this
    }
}(window.jQuery),
function(t) {
    "use strict";
    var e = function(t, e) {
        this.init("popover", t, e)
    };
    if (!t.fn.tooltip) throw new Error("Popover requires tooltip.js");
    e.DEFAULTS = t.extend({}, t.fn.tooltip.Constructor.DEFAULTS, {
        placement: "right",
        trigger: "click",
        content: "",
        template: '<div class="popover"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
    }), e.prototype = t.extend({}, t.fn.tooltip.Constructor.prototype), e.prototype.constructor = e, e.prototype.getDefaults = function() {
        return e.DEFAULTS
    }, e.prototype.setContent = function() {
        var t = this.tip(),
            e = this.getTitle(),
            n = this.getContent();
        t.find(".popover-title")[this.options.html ? "html" : "text"](e), t.find(".popover-content")[this.options.html ? "html" : "text"](n), t.removeClass("fade top bottom left right in"), t.find(".popover-title").html() || t.find(".popover-title").hide()
    }, e.prototype.hasContent = function() {
        return this.getTitle() || this.getContent()
    }, e.prototype.getContent = function() {
        var t = this.$element,
            e = this.options;
        return t.attr("data-content") || ("function" == typeof e.content ? e.content.call(t[0]) : e.content)
    }, e.prototype.arrow = function() {
        return this.$arrow = this.$arrow || this.tip().find(".arrow")
    }, e.prototype.tip = function() {
        return this.$tip || (this.$tip = t(this.options.template)), this.$tip
    };
    var n = t.fn.popover;
    t.fn.popover = function(n) {
        return this.each(function() {
            var i = t(this),
                o = i.data("bs.popover"),
                s = "object" == typeof n && n;
            o || i.data("bs.popover", o = new e(this, s)), "string" == typeof n && o[n]()
        })
    }, t.fn.popover.Constructor = e, t.fn.popover.noConflict = function() {
        return t.fn.popover = n, this
    }
}(window.jQuery),
function(t) {
    "use strict";

    function e(n, i) {
        var o, s = t.proxy(this.process, this);
        this.$element = t(t(n).is("body") ? window : n), this.$body = t("body"), this.$scrollElement = this.$element.on("scroll.bs.scroll-spy.data-api", s), this.options = t.extend({}, e.DEFAULTS, i), this.selector = (this.options.target || (o = t(n).attr("href")) && o.replace(/.*(?=#[^\s]+$)/, "") || "") + " .nav li > a", this.offsets = t([]), this.targets = t([]), this.activeTarget = null, this.refresh(), this.process()
    }
    e.DEFAULTS = {
        offset: 10
    }, e.prototype.refresh = function() {
        var e = this.$element[0] == window ? "offset" : "position";
        this.offsets = t([]), this.targets = t([]);
        var n = this;
        this.$body.find(this.selector).map(function() {
            var i = t(this),
                o = i.data("target") || i.attr("href"),
                s = /^#\w/.test(o) && t(o);
            return s && s.length && [
                [s[e]().top + (!t.isWindow(n.$scrollElement.get(0)) && n.$scrollElement.scrollTop()), o]
            ] || null
        }).sort(function(t, e) {
            return t[0] - e[0]
        }).each(function() {
            n.offsets.push(this[0]), n.targets.push(this[1])
        })
    }, e.prototype.process = function() {
        var t, e = this.$scrollElement.scrollTop() + this.options.offset,
            n = this.$scrollElement[0].scrollHeight || this.$body[0].scrollHeight,
            i = n - this.$scrollElement.height(),
            o = this.offsets,
            s = this.targets,
            r = this.activeTarget;
        if (e >= i) return r != (t = s.last()[0]) && this.activate(t);
        for (t = o.length; t--;) r != s[t] && e >= o[t] && (!o[t + 1] || e <= o[t + 1]) && this.activate(s[t])
    }, e.prototype.activate = function(e) {
        this.activeTarget = e, t(this.selector).parents(".active").removeClass("active");
        var n = this.selector + '[data-target="' + e + '"],' + this.selector + '[href="' + e + '"]',
            i = t(n).parents("li").addClass("active");
        i.parent(".dropdown-menu").length && (i = i.closest("li.dropdown").addClass("active")), i.trigger("activate")
    };
    var n = t.fn.scrollspy;
    t.fn.scrollspy = function(n) {
        return this.each(function() {
            var i = t(this),
                o = i.data("bs.scrollspy"),
                s = "object" == typeof n && n;
            o || i.data("bs.scrollspy", o = new e(this, s)), "string" == typeof n && o[n]()
        })
    }, t.fn.scrollspy.Constructor = e, t.fn.scrollspy.noConflict = function() {
        return t.fn.scrollspy = n, this
    }, t(window).on("load", function() {
        t('[data-spy="scroll"]').each(function() {
            var e = t(this);
            e.scrollspy(e.data())
        })
    })
}(window.jQuery),
function(t) {
    "use strict";
    var e = function(e) {
        this.element = t(e)
    };
    e.prototype.show = function() {
        var e = this.element,
            n = e.closest("ul:not(.dropdown-menu)"),
            i = e.attr("data-target");
        if (i || (i = e.attr("href"), i = i && i.replace(/.*(?=#[^\s]*$)/, "")), !e.parent("li").hasClass("active")) {
            var o = n.find(".active:last a")[0],
                s = t.Event("show.bs.tab", {
                    relatedTarget: o
                });
            if (e.trigger(s), !s.isDefaultPrevented()) {
                var r = t(i);
                this.activate(e.parent("li"), n), this.activate(r, r.parent(), function() {
                    e.trigger({
                        type: "shown.bs.tab",
                        relatedTarget: o
                    })
                })
            }
        }
    }, e.prototype.activate = function(e, n, i) {
        function o() {
            s.removeClass("active").find("> .dropdown-menu > .active").removeClass("active"), e.addClass("active"), r ? (e[0].offsetWidth, e.addClass("in")) : e.removeClass("fade"), e.parent(".dropdown-menu") && e.closest("li.dropdown").addClass("active"), i && i()
        }
        var s = n.find("> .active"),
            r = i && t.support.transition && s.hasClass("fade");
        r ? s.one(t.support.transition.end, o).emulateTransitionEnd(150) : o(), s.removeClass("in")
    };
    var n = t.fn.tab;
    t.fn.tab = function(n) {
        return this.each(function() {
            var i = t(this),
                o = i.data("bs.tab");
            o || i.data("bs.tab", o = new e(this)), "string" == typeof n && o[n]()
        })
    }, t.fn.tab.Constructor = e, t.fn.tab.noConflict = function() {
        return t.fn.tab = n, this
    }, t(document).on("click.bs.tab.data-api", '[data-toggle="tab"], [data-toggle="pill"]', function(e) {
        e.preventDefault(), t(this).tab("show")
    })
}(window.jQuery),
function(t) {
    "use strict";
    var e = function(n, i) {
        this.options = t.extend({}, e.DEFAULTS, i), this.$window = t(window).on("scroll.bs.affix.data-api", t.proxy(this.checkPosition, this)).on("click.bs.affix.data-api", t.proxy(this.checkPositionWithEventLoop, this)), this.$element = t(n), this.affixed = this.unpin = null, this.checkPosition()
    };
    e.RESET = "affix affix-top affix-bottom", e.DEFAULTS = {
        offset: 0
    }, e.prototype.checkPositionWithEventLoop = function() {
        setTimeout(t.proxy(this.checkPosition, this), 1)
    }, e.prototype.checkPosition = function() {
        if (this.$element.is(":visible")) {
            var n = t(document).height(),
                i = this.$window.scrollTop(),
                o = this.$element.offset(),
                s = this.options.offset,
                r = s.top,
                a = s.bottom;
            "object" != typeof s && (a = r = s), "function" == typeof r && (r = s.top()), "function" == typeof a && (a = s.bottom());
            var l = !(null != this.unpin && i + this.unpin <= o.top) && (null != a && o.top + this.$element.height() >= n - a ? "bottom" : null != r && r >= i && "top");
            this.affixed !== l && (this.unpin && this.$element.css("top", ""), this.affixed = l, this.unpin = "bottom" == l ? o.top - i : null, this.$element.removeClass(e.RESET).addClass("affix" + (l ? "-" + l : "")), "bottom" == l && this.$element.offset({
                top: document.body.offsetHeight - a - this.$element.height()
            }))
        }
    };
    var n = t.fn.affix;
    t.fn.affix = function(n) {
        return this.each(function() {
            var i = t(this),
                o = i.data("bs.affix"),
                s = "object" == typeof n && n;
            o || i.data("bs.affix", o = new e(this, s)), "string" == typeof n && o[n]()
        })
    }, t.fn.affix.Constructor = e, t.fn.affix.noConflict = function() {
        return t.fn.affix = n, this
    }, t(window).on("load", function() {
        t('[data-spy="affix"]').each(function() {
            var e = t(this),
                n = e.data();
            n.offset = n.offset || {}, n.offsetBottom && (n.offset.bottom = n.offsetBottom), n.offsetTop && (n.offset.top = n.offsetTop), e.affix(n)
        })
    })
}(window.jQuery),
function(t) {
    "function" == typeof define && define.amd ? define(["jquery"], t) : "object" == typeof module && module.exports ? module.exports = function(e, n) {
        return void 0 === n && (n = "undefined" != typeof window ? require("jquery") : require("jquery")(e)), t(n), n
    } : t(jQuery)
}(function(t) {
    var e = function() {
            if (t && t.fn && t.fn.select2 && t.fn.select2.amd) var e = t.fn.select2.amd;
            var e;
            return function() {
                if (!e || !e.requirejs) {
                    e ? n = e : e = {};
                    var t, n, i;
                    ! function(e) {
                        function o(t, e) {
                            return w.call(t, e)
                        }

                        function s(t, e) {
                            var n, i, o, s, r, a, l, c, d, u, p, h, f = e && e.split("/"),
                                g = b.map,
                                m = g && g["*"] || {};
                            if (t) {
                                for (t = t.split("/"), r = t.length - 1, b.nodeIdCompat && C.test(t[r]) && (t[r] = t[r].replace(C, "")), "." === t[0].charAt(0) && f && (h = f.slice(0, f.length - 1), t = h.concat(t)), d = 0; d < t.length; d++)
                                    if ("." === (p = t[d])) t.splice(d, 1), d -= 1;
                                    else if (".." === p) {
                                    if (0 === d || 1 === d && ".." === t[2] || ".." === t[d - 1]) continue;
                                    d > 0 && (t.splice(d - 1, 2), d -= 2)
                                }
                                t = t.join("/")
                            }
                            if ((f || m) && g) {
                                for (n = t.split("/"), d = n.length; d > 0; d -= 1) {
                                    if (i = n.slice(0, d).join("/"), f)
                                        for (u = f.length; u > 0; u -= 1)
                                            if ((o = g[f.slice(0, u).join("/")]) && (o = o[i])) {
                                                s = o, a = d;
                                                break
                                            }
                                    if (s) break;
                                    !l && m && m[i] && (l = m[i], c = d)
                                }!s && l && (s = l, a = c), s && (n.splice(0, a, s), t = n.join("/"))
                            }
                            return t
                        }

                        function r(t, n) {
                            return function() {
                                var i = _.call(arguments, 0);
                                return "string" != typeof i[0] && 1 === i.length && i.push(null), f.apply(e, i.concat([t, n]))
                            }
                        }

                        function a(t) {
                            return function(e) {
                                return s(e, t)
                            }
                        }

                        function l(t) {
                            return function(e) {
                                v[t] = e
                            }
                        }

                        function c(t) {
                            if (o(y, t)) {
                                var n = y[t];
                                delete y[t], $[t] = !0, h.apply(e, n)
                            }
                            if (!o(v, t) && !o($, t)) throw new Error("No " + t);
                            return v[t]
                        }

                        function d(t) {
                            var e, n = t ? t.indexOf("!") : -1;
                            return n > -1 && (e = t.substring(0, n), t = t.substring(n + 1, t.length)), [e, t]
                        }

                        function u(t) {
                            return t ? d(t) : []
                        }

                        function p(t) {
                            return function() {
                                return b && b.config && b.config[t] || {}
                            }
                        }
                        var h, f, g, m, v = {},
                            y = {},
                            b = {},
                            $ = {},
                            w = Object.prototype.hasOwnProperty,
                            _ = [].slice,
                            C = /\.js$/;
                        g = function(t, e) {
                            var n, i = d(t),
                                o = i[0],
                                r = e[1];
                            return t = i[1], o && (o = s(o, r), n = c(o)), o ? t = n && n.normalize ? n.normalize(t, a(r)) : s(t, r) : (t = s(t, r), i = d(t), o = i[0], t = i[1], o && (n = c(o))), {
                                f: o ? o + "!" + t : t,
                                n: t,
                                pr: o,
                                p: n
                            }
                        }, m = {
                            require: function(t) {
                                return r(t)
                            },
                            exports: function(t) {
                                var e = v[t];
                                return void 0 !== e ? e : v[t] = {}
                            },
                            module: function(t) {
                                return {
                                    id: t,
                                    uri: "",
                                    exports: v[t],
                                    config: p(t)
                                }
                            }
                        }, h = function(t, n, i, s) {
                            var a, d, p, h, f, b, w, _ = [],
                                C = typeof i;
                            if (s = s || t, b = u(s), "undefined" === C || "function" === C) {
                                for (n = !n.length && i.length ? ["require", "exports", "module"] : n, f = 0; f < n.length; f += 1)
                                    if (h = g(n[f], b), "require" === (d = h.f)) _[f] = m.require(t);
                                    else if ("exports" === d) _[f] = m.exports(t), w = !0;
                                else if ("module" === d) a = _[f] = m.module(t);
                                else if (o(v, d) || o(y, d) || o($, d)) _[f] = c(d);
                                else {
                                    if (!h.p) throw new Error(t + " missing " + d);
                                    h.p.load(h.n, r(s, !0), l(d), {}), _[f] = v[d]
                                }
                                p = i ? i.apply(v[t], _) : void 0, t && (a && a.exports !== e && a.exports !== v[t] ? v[t] = a.exports : p === e && w || (v[t] = p))
                            } else t && (v[t] = i)
                        }, t = n = f = function(t, n, i, o, s) {
                            if ("string" == typeof t) return m[t] ? m[t](n) : c(g(t, u(n)).f);
                            if (!t.splice) {
                                if (b = t, b.deps && f(b.deps, b.callback), !n) return;
                                n.splice ? (t = n, n = i, i = null) : t = e
                            }
                            return n = n || function() {}, "function" == typeof i && (i = o, o = s), o ? h(e, t, n, i) : setTimeout(function() {
                                h(e, t, n, i)
                            }, 4), f
                        }, f.config = function(t) {
                            return f(t)
                        }, t._defined = v, i = function(t, e, n) {
                            if ("string" != typeof t) throw new Error("See almond README: incorrect module build, no module name");
                            e.splice || (n = e, e = []), o(v, t) || o(y, t) || (y[t] = [t, e, n])
                        }, i.amd = {
                            jQuery: !0
                        }
                    }(), e.requirejs = t, e.require = n, e.define = i
                }
            }(), e.define("almond", function() {}), e.define("jquery", [], function() {
                var e = t || $;
                return null == e && console && console.error && console.error("Select2: An instance of jQuery or a jQuery-compatible library was not found. Make sure that you are including jQuery before Select2 on your web page."), e
            }), e.define("select2/utils", ["jquery"], function(t) {
                function e(t) {
                    var e = t.prototype,
                        n = [];
                    for (var i in e) "function" == typeof e[i] && "constructor" !== i && n.push(i);
                    return n
                }
                var n = {};
                n.Extend = function(t, e) {
                    function n() {
                        this.constructor = t
                    }
                    var i = {}.hasOwnProperty;
                    for (var o in e) i.call(e, o) && (t[o] = e[o]);
                    return n.prototype = e.prototype, t.prototype = new n, t.__super__ = e.prototype, t
                }, n.Decorate = function(t, n) {
                    function i() {
                        var e = Array.prototype.unshift,
                            i = n.prototype.constructor.length,
                            o = t.prototype.constructor;
                        i > 0 && (e.call(arguments, t.prototype.constructor), o = n.prototype.constructor), o.apply(this, arguments)
                    }

                    function o() {
                        this.constructor = i
                    }
                    var s = e(n),
                        r = e(t);
                    n.displayName = t.displayName, i.prototype = new o;
                    for (var a = 0; a < r.length; a++) {
                        var l = r[a];
                        i.prototype[l] = t.prototype[l]
                    }
                    for (var c = 0; c < s.length; c++) {
                        var d = s[c];
                        i.prototype[d] = function(t) {
                            var e = function() {};
                            t in i.prototype && (e = i.prototype[t]);
                            var o = n.prototype[t];
                            return function() {
                                return Array.prototype.unshift.call(arguments, e), o.apply(this, arguments)
                            }
                        }(d)
                    }
                    return i
                };
                var i = function() {
                    this.listeners = {}
                };
                return i.prototype.on = function(t, e) {
                    this.listeners = this.listeners || {}, t in this.listeners ? this.listeners[t].push(e) : this.listeners[t] = [e]
                }, i.prototype.trigger = function(t) {
                    var e = Array.prototype.slice,
                        n = e.call(arguments, 1);
                    this.listeners = this.listeners || {}, null == n && (n = []), 0 === n.length && n.push({}), n[0]._type = t, t in this.listeners && this.invoke(this.listeners[t], e.call(arguments, 1)), "*" in this.listeners && this.invoke(this.listeners["*"], arguments)
                }, i.prototype.invoke = function(t, e) {
                    for (var n = 0, i = t.length; n < i; n++) t[n].apply(this, e)
                }, n.Observable = i, n.generateChars = function(t) {
                    for (var e = "", n = 0; n < t; n++) e += Math.floor(36 * Math.random()).toString(36);
                    return e
                }, n.bind = function(t, e) {
                    return function() {
                        t.apply(e, arguments)
                    }
                }, n._convertData = function(t) {
                    for (var e in t) {
                        var n = e.split("-"),
                            i = t;
                        if (1 !== n.length) {
                            for (var o = 0; o < n.length; o++) {
                                var s = n[o];
                                s = s.substring(0, 1).toLowerCase() + s.substring(1), s in i || (i[s] = {}), o == n.length - 1 && (i[s] = t[e]), i = i[s]
                            }
                            delete t[e]
                        }
                    }
                    return t
                }, n.hasScroll = function(e, n) {
                    var i = t(n),
                        o = n.style.overflowX,
                        s = n.style.overflowY;
                    return (o !== s || "hidden" !== s && "visible" !== s) && ("scroll" === o || "scroll" === s || i.innerHeight() < n.scrollHeight || i.innerWidth() < n.scrollWidth)
                }, n.escapeMarkup = function(t) {
                    var e = {
                        "\\": "&#92;",
                        "&": "&amp;",
                        "<": "&lt;",
                        ">": "&gt;",
                        '"': "&quot;",
                        "'": "&#39;",
                        "/": "&#47;"
                    };
                    return "string" != typeof t ? t : String(t).replace(/[&<>"'\/\\]/g, function(t) {
                        return e[t]
                    })
                }, n.appendMany = function(e, n) {
                    if ("1.7" === t.fn.jquery.substr(0, 3)) {
                        var i = t();
                        t.map(n, function(t) {
                            i = i.add(t)
                        }), n = i
                    }
                    e.append(n)
                }, n
            }), e.define("select2/results", ["jquery", "./utils"], function(t, e) {
                function n(t, e, i) {
                    this.$element = t, this.data = i, this.options = e, n.__super__.constructor.call(this)
                }
                return e.Extend(n, e.Observable), n.prototype.render = function() {
                    var e = t('<ul class="select2-results__options" role="tree"></ul>');
                    return this.options.get("multiple") && e.attr("aria-multiselectable", "true"), this.$results = e, e
                }, n.prototype.clear = function() {
                    this.$results.empty()
                }, n.prototype.displayMessage = function(e) {
                    var n = this.options.get("escapeMarkup");
                    this.clear(), this.hideLoading();
                    var i = t('<li role="treeitem" aria-live="assertive" class="select2-results__option"></li>'),
                        o = this.options.get("translations").get(e.message);
                    i.append(n(o(e.args))), i[0].className += " select2-results__message", this.$results.append(i)
                }, n.prototype.hideMessages = function() {
                    this.$results.find(".select2-results__message").remove()
                }, n.prototype.append = function(t) {
                    this.hideLoading();
                    var e = [];
                    if (null == t.results || 0 === t.results.length) return void(0 === this.$results.children().length && this.trigger("results:message", {
                        message: "noResults"
                    }));
                    t.results = this.sort(t.results);
                    for (var n = 0; n < t.results.length; n++) {
                        var i = t.results[n],
                            o = this.option(i);
                        e.push(o)
                    }
                    this.$results.append(e)
                }, n.prototype.position = function(t, e) {
                    e.find(".select2-results").append(t)
                }, n.prototype.sort = function(t) {
                    return this.options.get("sorter")(t)
                }, n.prototype.highlightFirstItem = function() {
                    var t = this.$results.find(".select2-results__option[aria-selected]"),
                        e = t.filter("[aria-selected=true]");
                    e.length > 0 ? e.first().trigger("mouseenter") : t.first().trigger("mouseenter"), this.ensureHighlightVisible()
                }, n.prototype.setClasses = function() {
                    var e = this;
                    this.data.current(function(n) {
                        var i = t.map(n, function(t) {
                            return t.id.toString()
                        });
                        e.$results.find(".select2-results__option[aria-selected]").each(function() {
                            var e = t(this),
                                n = t.data(this, "data"),
                                o = "" + n.id;
                            null != n.element && n.element.selected || null == n.element && t.inArray(o, i) > -1 ? e.attr("aria-selected", "true") : e.attr("aria-selected", "false")
                        })
                    })
                }, n.prototype.showLoading = function(t) {
                    this.hideLoading();
                    var e = this.options.get("translations").get("searching"),
                        n = {
                            disabled: !0,
                            loading: !0,
                            text: e(t)
                        },
                        i = this.option(n);
                    i.className += " loading-results", this.$results.prepend(i)
                }, n.prototype.hideLoading = function() {
                    this.$results.find(".loading-results").remove()
                }, n.prototype.option = function(e) {
                    var n = document.createElement("li");
                    n.className = "select2-results__option";
                    var i = {
                        role: "treeitem",
                        "aria-selected": "false"
                    };
                    e.disabled && (delete i["aria-selected"], i["aria-disabled"] = "true"), null == e.id && delete i["aria-selected"], null != e._resultId && (n.id = e._resultId), e.title && (n.title = e.title), e.children && (i.role = "group", i["aria-label"] = e.text, delete i["aria-selected"]);
                    for (var o in i) {
                        var s = i[o];
                        n.setAttribute(o, s)
                    }
                    if (e.children) {
                        var r = t(n),
                            a = document.createElement("strong");
                        a.className = "select2-results__group", t(a), this.template(e, a);
                        for (var l = [], c = 0; c < e.children.length; c++) {
                            var d = e.children[c],
                                u = this.option(d);
                            l.push(u)
                        }
                        var p = t("<ul></ul>", {
                            class: "select2-results__options select2-results__options--nested"
                        });
                        p.append(l), r.append(a), r.append(p)
                    } else this.template(e, n);
                    return t.data(n, "data", e), n
                }, n.prototype.bind = function(e, n) {
                    var i = this,
                        o = e.id + "-results";
                    this.$results.attr("id", o), e.on("results:all", function(t) {
                        i.clear(), i.append(t.data), e.isOpen() && (i.setClasses(), i.highlightFirstItem())
                    }), e.on("results:append", function(t) {
                        i.append(t.data), e.isOpen() && i.setClasses()
                    }), e.on("query", function(t) {
                        i.hideMessages(), i.showLoading(t)
                    }), e.on("select", function() {
                        e.isOpen() && (i.setClasses(), i.highlightFirstItem())
                    }), e.on("unselect", function() {
                        e.isOpen() && (i.setClasses(), i.highlightFirstItem())
                    }), e.on("open", function() {
                        i.$results.attr("aria-expanded", "true"), i.$results.attr("aria-hidden", "false"), i.setClasses(), i.ensureHighlightVisible()
                    }), e.on("close", function() {
                        i.$results.attr("aria-expanded", "false"), i.$results.attr("aria-hidden", "true"), i.$results.removeAttr("aria-activedescendant")
                    }), e.on("results:toggle", function() {
                        var t = i.getHighlightedResults();
                        0 !== t.length && t.trigger("mouseup")
                    }), e.on("results:select", function() {
                        var t = i.getHighlightedResults();
                        if (0 !== t.length) {
                            var e = t.data("data");
                            "true" == t.attr("aria-selected") ? i.trigger("close", {}) : i.trigger("select", {
                                data: e
                            })
                        }
                    }), e.on("results:previous", function() {
                        var t = i.getHighlightedResults(),
                            e = i.$results.find("[aria-selected]"),
                            n = e.index(t);
                        if (0 !== n) {
                            var o = n - 1;
                            0 === t.length && (o = 0);
                            var s = e.eq(o);
                            s.trigger("mouseenter");
                            var r = i.$results.offset().top,
                                a = s.offset().top,
                                l = i.$results.scrollTop() + (a - r);
                            0 === o ? i.$results.scrollTop(0) : a - r < 0 && i.$results.scrollTop(l)
                        }
                    }), e.on("results:next", function() {
                        var t = i.getHighlightedResults(),
                            e = i.$results.find("[aria-selected]"),
                            n = e.index(t),
                            o = n + 1;
                        if (!(o >= e.length)) {
                            var s = e.eq(o);
                            s.trigger("mouseenter");
                            var r = i.$results.offset().top + i.$results.outerHeight(!1),
                                a = s.offset().top + s.outerHeight(!1),
                                l = i.$results.scrollTop() + a - r;
                            0 === o ? i.$results.scrollTop(0) : a > r && i.$results.scrollTop(l)
                        }
                    }), e.on("results:focus", function(t) {
                        t.element.addClass("select2-results__option--highlighted")
                    }), e.on("results:message", function(t) {
                        i.displayMessage(t)
                    }), t.fn.mousewheel && this.$results.on("mousewheel", function(t) {
                        var e = i.$results.scrollTop(),
                            n = i.$results.get(0).scrollHeight - e + t.deltaY,
                            o = t.deltaY > 0 && e - t.deltaY <= 0,
                            s = t.deltaY < 0 && n <= i.$results.height();
                        o ? (i.$results.scrollTop(0), t.preventDefault(), t.stopPropagation()) : s && (i.$results.scrollTop(i.$results.get(0).scrollHeight - i.$results.height()), t.preventDefault(), t.stopPropagation())
                    }), this.$results.on("mouseup", ".select2-results__option[aria-selected]", function(e) {
                        var n = t(this),
                            o = n.data("data");
                        if ("true" === n.attr("aria-selected")) return void(i.options.get("multiple") ? i.trigger("unselect", {
                            originalEvent: e,
                            data: o
                        }) : i.trigger("close", {}));
                        i.trigger("select", {
                            originalEvent: e,
                            data: o
                        })
                    }), this.$results.on("mouseenter", ".select2-results__option[aria-selected]", function(e) {
                        var n = t(this).data("data");
                        i.getHighlightedResults().removeClass("select2-results__option--highlighted"), i.trigger("results:focus", {
                            data: n,
                            element: t(this)
                        })
                    })
                }, n.prototype.getHighlightedResults = function() {
                    return this.$results.find(".select2-results__option--highlighted")
                }, n.prototype.destroy = function() {
                    this.$results.remove()
                }, n.prototype.ensureHighlightVisible = function() {
                    var t = this.getHighlightedResults();
                    if (0 !== t.length) {
                        var e = this.$results.find("[aria-selected]"),
                            n = e.index(t),
                            i = this.$results.offset().top,
                            o = t.offset().top,
                            s = this.$results.scrollTop() + (o - i),
                            r = o - i;
                        s -= 2 * t.outerHeight(!1), n <= 2 ? this.$results.scrollTop(0) : (r > this.$results.outerHeight() || r < 0) && this.$results.scrollTop(s)
                    }
                }, n.prototype.template = function(e, n) {
                    var i = this.options.get("templateResult"),
                        o = this.options.get("escapeMarkup"),
                        s = i(e, n);
                    null == s ? n.style.display = "none" : "string" == typeof s ? n.innerHTML = o(s) : t(n).append(s)
                }, n
            }), e.define("select2/keys", [], function() {
                return {
                    BACKSPACE: 8,
                    TAB: 9,
                    ENTER: 13,
                    SHIFT: 16,
                    CTRL: 17,
                    ALT: 18,
                    ESC: 27,
                    SPACE: 32,
                    PAGE_UP: 33,
                    PAGE_DOWN: 34,
                    END: 35,
                    HOME: 36,
                    LEFT: 37,
                    UP: 38,
                    RIGHT: 39,
                    DOWN: 40,
                    DELETE: 46
                }
            }), e.define("select2/selection/base", ["jquery", "../utils", "../keys"], function(t, e, n) {
                function i(t, e) {
                    this.$element = t, this.options = e, i.__super__.constructor.call(this)
                }
                return e.Extend(i, e.Observable), i.prototype.render = function() {
                    var e = t('<span class="select2-selection" role="combobox"  aria-haspopup="true" aria-expanded="false"></span>');
                    return this._tabindex = 0, null != this.$element.data("old-tabindex") ? this._tabindex = this.$element.data("old-tabindex") : null != this.$element.attr("tabindex") && (this._tabindex = this.$element.attr("tabindex")), e.attr("title", this.$element.attr("title")), e.attr("tabindex", this._tabindex), this.$selection = e, e
                }, i.prototype.bind = function(t, e) {
                    var i = this,
                        o = (t.id, t.id + "-results");
                    this.container = t, this.$selection.on("focus", function(t) {
                        i.trigger("focus", t)
                    }), this.$selection.on("blur", function(t) {
                        i._handleBlur(t)
                    }), this.$selection.on("keydown", function(t) {
                        i.trigger("keypress", t), t.which === n.SPACE && t.preventDefault()
                    }), t.on("results:focus", function(t) {
                        i.$selection.attr("aria-activedescendant", t.data._resultId)
                    }), t.on("selection:update", function(t) {
                        i.update(t.data)
                    }), t.on("open", function() {
                        i.$selection.attr("aria-expanded", "true"), i.$selection.attr("aria-owns", o), i._attachCloseHandler(t)
                    }), t.on("close", function() {
                        i.$selection.attr("aria-expanded", "false"), i.$selection.removeAttr("aria-activedescendant"), i.$selection.removeAttr("aria-owns"), i.$selection.focus(), i._detachCloseHandler(t)
                    }), t.on("enable", function() {
                        i.$selection.attr("tabindex", i._tabindex)
                    }), t.on("disable", function() {
                        i.$selection.attr("tabindex", "-1")
                    })
                }, i.prototype._handleBlur = function(e) {
                    var n = this;
                    window.setTimeout(function() {
                        document.activeElement == n.$selection[0] || t.contains(n.$selection[0], document.activeElement) || n.trigger("blur", e)
                    }, 1)
                }, i.prototype._attachCloseHandler = function(e) {
                    t(document.body).on("mousedown.select2." + e.id, function(e) {
                        var n = t(e.target),
                            i = n.closest(".select2");
                        t(".select2.select2-container--open").each(function() {
                            var e = t(this);
                            this != i[0] && e.data("element").select2("close")
                        })
                    })
                }, i.prototype._detachCloseHandler = function(e) {
                    t(document.body).off("mousedown.select2." + e.id)
                }, i.prototype.position = function(t, e) {
                    e.find(".selection").append(t)
                }, i.prototype.destroy = function() {
                    this._detachCloseHandler(this.container)
                }, i.prototype.update = function(t) {
                    throw new Error("The `update` method must be defined in child classes.")
                }, i
            }), e.define("select2/selection/single", ["jquery", "./base", "../utils", "../keys"], function(t, e, n, i) {
                function o() {
                    o.__super__.constructor.apply(this, arguments)
                }
                return n.Extend(o, e), o.prototype.render = function() {
                    var t = o.__super__.render.call(this);
                    return t.addClass("select2-selection--single"), t.html('<span class="select2-selection__rendered"></span><span class="select2-selection__arrow" role="presentation"><b role="presentation"></b></span>'), t
                }, o.prototype.bind = function(t, e) {
                    var n = this;
                    o.__super__.bind.apply(this, arguments);
                    var i = t.id + "-container";
                    this.$selection.find(".select2-selection__rendered").attr("id", i), this.$selection.attr("aria-labelledby", i), this.$selection.on("mousedown", function(t) {
                        1 === t.which && n.trigger("toggle", {
                            originalEvent: t
                        })
                    }), this.$selection.on("focus", function(t) {}), this.$selection.on("blur", function(t) {}), t.on("focus", function(e) {
                        t.isOpen() || n.$selection.focus()
                    }), t.on("selection:update", function(t) {
                        n.update(t.data)
                    })
                }, o.prototype.clear = function() {
                    this.$selection.find(".select2-selection__rendered").empty()
                }, o.prototype.display = function(t, e) {
                    var n = this.options.get("templateSelection");
                    return this.options.get("escapeMarkup")(n(t, e))
                }, o.prototype.selectionContainer = function() {
                    return t("<span></span>")
                }, o.prototype.update = function(t) {
                    if (0 === t.length) return void this.clear();
                    var e = t[0],
                        n = this.$selection.find(".select2-selection__rendered"),
                        i = this.display(e, n);
                    n.empty().append(i), n.prop("title", e.title || e.text)
                }, o
            }), e.define("select2/selection/multiple", ["jquery", "./base", "../utils"], function(t, e, n) {
                function i(t, e) {
                    i.__super__.constructor.apply(this, arguments)
                }
                return n.Extend(i, e), i.prototype.render = function() {
                    var t = i.__super__.render.call(this);
                    return t.addClass("select2-selection--multiple"), t.html('<ul class="select2-selection__rendered"></ul>'), t
                }, i.prototype.bind = function(e, n) {
                    var o = this;
                    i.__super__.bind.apply(this, arguments), this.$selection.on("click", function(t) {
                        o.trigger("toggle", {
                            originalEvent: t
                        })
                    }), this.$selection.on("click", ".select2-selection__choice__remove", function(e) {
                        if (!o.options.get("disabled")) {
                            var n = t(this),
                                i = n.parent(),
                                s = i.data("data");
                            o.trigger("unselect", {
                                originalEvent: e,
                                data: s
                            })
                        }
                    })
                }, i.prototype.clear = function() {
                    this.$selection.find(".select2-selection__rendered").empty()
                }, i.prototype.display = function(t, e) {
                    var n = this.options.get("templateSelection");
                    return this.options.get("escapeMarkup")(n(t, e))
                }, i.prototype.selectionContainer = function() {
                    return t('<li class="select2-selection__choice"><span class="select2-selection__choice__remove" role="presentation">&times;</span></li>')
                }, i.prototype.update = function(t) {
                    if (this.clear(), 0 !== t.length) {
                        for (var e = [], i = 0; i < t.length; i++) {
                            var o = t[i],
                                s = this.selectionContainer(),
                                r = this.display(o, s);
                            s.append(r), s.prop("title", o.title || o.text), s.data("data", o), e.push(s)
                        }
                        var a = this.$selection.find(".select2-selection__rendered");
                        n.appendMany(a, e)
                    }
                }, i
            }), e.define("select2/selection/placeholder", ["../utils"], function(t) {
                function e(t, e, n) {
                    this.placeholder = this.normalizePlaceholder(n.get("placeholder")), t.call(this, e, n)
                }
                return e.prototype.normalizePlaceholder = function(t, e) {
                    return "string" == typeof e && (e = {
                        id: "",
                        text: e
                    }), e
                }, e.prototype.createPlaceholder = function(t, e) {
                    var n = this.selectionContainer();
                    return n.html(this.display(e)), n.addClass("select2-selection__placeholder").removeClass("select2-selection__choice"), n
                }, e.prototype.update = function(t, e) {
                    var n = 1 == e.length && e[0].id != this.placeholder.id;
                    if (e.length > 1 || n) return t.call(this, e);
                    this.clear();
                    var i = this.createPlaceholder(this.placeholder);
                    this.$selection.find(".select2-selection__rendered").append(i)
                }, e
            }), e.define("select2/selection/allowClear", ["jquery", "../keys"], function(t, e) {
                function n() {}
                return n.prototype.bind = function(t, e, n) {
                    var i = this;
                    t.call(this, e, n), null == this.placeholder && this.options.get("debug") && window.console && console.error && console.error("Select2: The `allowClear` option should be used in combination with the `placeholder` option."), this.$selection.on("mousedown", ".select2-selection__clear", function(t) {
                        i._handleClear(t)
                    }), e.on("keypress", function(t) {
                        i._handleKeyboardClear(t, e)
                    })
                }, n.prototype._handleClear = function(t, e) {
                    if (!this.options.get("disabled")) {
                        var n = this.$selection.find(".select2-selection__clear");
                        if (0 !== n.length) {
                            e.stopPropagation();
                            for (var i = n.data("data"), o = 0; o < i.length; o++) {
                                var s = {
                                    data: i[o]
                                };
                                if (this.trigger("unselect", s), s.prevented) return
                            }
                            this.$element.val(this.placeholder.id).trigger("change"), this.trigger("toggle", {})
                        }
                    }
                }, n.prototype._handleKeyboardClear = function(t, n, i) {
                    i.isOpen() || n.which != e.DELETE && n.which != e.BACKSPACE || this._handleClear(n)
                }, n.prototype.update = function(e, n) {
                    if (e.call(this, n), !(this.$selection.find(".select2-selection__placeholder").length > 0 || 0 === n.length)) {
                        var i = t('<span class="select2-selection__clear">&times;</span>');
                        i.data("data", n), this.$selection.find(".select2-selection__rendered").prepend(i)
                    }
                }, n
            }), e.define("select2/selection/search", ["jquery", "../utils", "../keys"], function(t, e, n) {
                function i(t, e, n) {
                    t.call(this, e, n)
                }
                return i.prototype.render = function(e) {
                    var n = t('<li class="select2-search select2-search--inline"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="textbox" aria-autocomplete="list" /></li>');
                    this.$searchContainer = n, this.$search = n.find("input");
                    var i = e.call(this);
                    return this._transferTabIndex(), i
                }, i.prototype.bind = function(t, e, i) {
                    var o = this;
                    t.call(this, e, i), e.on("open", function() {
                        o.$search.trigger("focus")
                    }), e.on("close", function() {
                        o.$search.val(""), o.$search.removeAttr("aria-activedescendant"), o.$search.trigger("focus")
                    }), e.on("enable", function() {
                        o.$search.prop("disabled", !1), o._transferTabIndex()
                    }), e.on("disable", function() {
                        o.$search.prop("disabled", !0)
                    }), e.on("focus", function(t) {
                        o.$search.trigger("focus")
                    }), e.on("results:focus", function(t) {
                        o.$search.attr("aria-activedescendant", t.id)
                    }), this.$selection.on("focusin", ".select2-search--inline", function(t) {
                        o.trigger("focus", t)
                    }), this.$selection.on("focusout", ".select2-search--inline", function(t) {
                        o._handleBlur(t)
                    }), this.$selection.on("keydown", ".select2-search--inline", function(t) {
                        if (t.stopPropagation(), o.trigger("keypress", t), o._keyUpPrevented = t.isDefaultPrevented(), t.which === n.BACKSPACE && "" === o.$search.val()) {
                            var e = o.$searchContainer.prev(".select2-selection__choice");
                            if (e.length > 0) {
                                var i = e.data("data");
                                o.searchRemoveChoice(i), t.preventDefault()
                            }
                        }
                    });
                    var s = document.documentMode,
                        r = s && s <= 11;
                    this.$selection.on("input.searchcheck", ".select2-search--inline", function(t) {
                        if (r) return void o.$selection.off("input.search input.searchcheck");
                        o.$selection.off("keyup.search")
                    }), this.$selection.on("keyup.search input.search", ".select2-search--inline", function(t) {
                        if (r && "input" === t.type) return void o.$selection.off("input.search input.searchcheck");
                        var e = t.which;
                        e != n.SHIFT && e != n.CTRL && e != n.ALT && e != n.TAB && o.handleSearch(t)
                    })
                }, i.prototype._transferTabIndex = function(t) {
                    this.$search.attr("tabindex", this.$selection.attr("tabindex")), this.$selection.attr("tabindex", "-1")
                }, i.prototype.createPlaceholder = function(t, e) {
                    this.$search.attr("placeholder", e.text)
                }, i.prototype.update = function(t, e) {
                    var n = this.$search[0] == document.activeElement;
                    this.$search.attr("placeholder", ""), t.call(this, e), this.$selection.find(".select2-selection__rendered").append(this.$searchContainer), this.resizeSearch(), n && this.$search.focus()
                }, i.prototype.handleSearch = function() {
                    if (this.resizeSearch(), !this._keyUpPrevented) {
                        var t = this.$search.val();
                        this.trigger("query", {
                            term: t
                        })
                    }
                    this._keyUpPrevented = !1
                }, i.prototype.searchRemoveChoice = function(t, e) {
                    this.trigger("unselect", {
                        data: e
                    }), this.$search.val(e.text), this.handleSearch()
                }, i.prototype.resizeSearch = function() {
                    this.$search.css("width", "25px");
                    var t = "";
                    t = "" !== this.$search.attr("placeholder") ? this.$selection.find(".select2-selection__rendered").innerWidth() : .75 * (this.$search.val().length + 1) + "em", this.$search.css("width", t)
                }, i
            }), e.define("select2/selection/eventRelay", ["jquery"], function(t) {
                function e() {}
                return e.prototype.bind = function(e, n, i) {
                    var o = this,
                        s = ["open", "opening", "close", "closing", "select", "selecting", "unselect", "unselecting"],
                        r = ["opening", "closing", "selecting", "unselecting"];
                    e.call(this, n, i), n.on("*", function(e, n) {
                        if (-1 !== t.inArray(e, s)) {
                            n = n || {};
                            var i = t.Event("select2:" + e, {
                                params: n
                            });
                            o.$element.trigger(i), -1 !== t.inArray(e, r) && (n.prevented = i.isDefaultPrevented())
                        }
                    })
                }, e
            }), e.define("select2/translation", ["jquery", "require"], function(t, e) {
                function n(t) {
                    this.dict = t || {}
                }
                return n.prototype.all = function() {
                    return this.dict
                }, n.prototype.get = function(t) {
                    return this.dict[t]
                }, n.prototype.extend = function(e) {
                    this.dict = t.extend({}, e.all(), this.dict)
                }, n._cache = {}, n.loadPath = function(t) {
                    if (!(t in n._cache)) {
                        var i = e(t);
                        n._cache[t] = i
                    }
                    return new n(n._cache[t])
                }, n
            }), e.define("select2/diacritics", [], function() {
                return {
                    "â’¶": "A",
                    "ï¼¡": "A",
                    "Ã€": "A",
                    "Ã": "A",
                    "Ã‚": "A",
                    "áº¦": "A",
                    "áº¤": "A",
                    "áºª": "A",
                    "áº¨": "A",
                    "Ãƒ": "A",
                    "Ä€": "A",
                    "Ä‚": "A",
                    "áº°": "A",
                    "áº®": "A",
                    "áº´": "A",
                    "áº²": "A",
                    "È¦": "A",
                    "ï¿½ ": "A",
                    "Ã„": "A",
                    "Çž": "A",
                    "áº¢": "A",
                    "Ã…": "A",
                    "Çº": "A",
                    "Ç": "A",
                    "È€": "A",
                    "È‚": "A",
                    "ï¿½ï¿½ ": "A",
                    "áº¬": "A",
                    "áº¶": "A",
                    "á¸€": "A",
                    "Ä„": "A",
                    "Èº": "A",
                    "â±¯": "A",
                    "êœ²": "AA",
                    "Ã†": "AE",
                    "Ç¼": "AE",
                    "Ç¢": "AE",
                    "êœ´": "AO",
                    "êœ¶": "AU",
                    "êœ¸": "AV",
                    "êœº": "AV",
                    "êœ¼": "AY",
                    "â’·": "B",
                    "ï¼¢": "B",
                    "á¸‚": "B",
                    "á¸„": "B",
                    "á¸†": "B",
                    "Éƒ": "B",
                    "Æ‚": "B",
                    "Æ": "B",
                    "â’¸": "C",
                    "ï¼£": "C",
                    "Ä†": "C",
                    "Äˆ": "C",
                    "ÄŠ": "C",
                    "ÄŒ": "C",
                    "Ã‡": "C",
                    "á¸ˆ": "C",
                    "Æ‡": "C",
                    "È»": "C",
                    "êœ¾": "C",
                    "â’¹": "D",
                    "ï¼¤": "D",
                    "á¸Š": "D",
                    "ÄŽ": "D",
                    "á¸Œ": "D",
                    "á¸": "D",
                    "á¸’": "D",
                    "á¸Ž": "D",
                    "Ä": "D",
                    "Æ‹": "D",
                    "ÆŠ": "D",
                    "Æ‰": "D",
                    "ê¹": "D",
                    "Ç±": "DZ",
                    "Ç„": "DZ",
                    "Ç²": "Dz",
                    "Ç…": "Dz",
                    "â’º": "E",
                    "ï¼¥": "E",
                    "Ãˆ": "E",
                    "Ã‰": "E",
                    "ÃŠ": "E",
                    "á»€": "E",
                    "áº¾": "E",
                    "á»„": "E",
                    "á»‚": "E",
                    "áº¼": "E",
                    "Ä’": "E",
                    "á¸”": "E",
                    "á¸–": "E",
                    "Ä”": "E",
                    "Ä–": "E",
                    "Ã‹": "E",
                    "áºº": "E",
                    "Äš": "E",
                    "È„": "E",
                    "È†": "E",
                    "áº¸": "E",
                    "á»†": "E",
                    "È¨": "E",
                    "á¸œ": "E",
                    "Ä˜": "E",
                    "á¸˜": "E",
                    "á¸š": "E",
                    "Æ": "E",
                    "ÆŽ": "E",
                    "â’»": "F",
                    "ï¼¦": "F",
                    "á¸ž": "F",
                    "Æ‘": "F",
                    "ê»": "F",
                    "â’¼": "G",
                    "ï¼§": "G",
                    "Ç´": "G",
                    "Äœ": "G",
                    "ï¿½ï¿½ ": "G",
                    "Äž": "G",
                    "ï¿½ ": "G",
                    "Ç¦": "G",
                    "Ä¢": "G",
                    "Ç¤": "G",
                    "Æ“": "G",
                    "ï¿½ï¿½ ": "G",
                    "ê½": "G",
                    "ê¾": "G",
                    "â’½": "H",
                    "ï¼¨": "H",
                    "Ä¤": "H",
                    "á¸¢": "H",
                    "á¸¦": "H",
                    "Èž": "H",
                    "á¸¤": "H",
                    "á¸¨": "H",
                    "á¸ª": "H",
                    "Ä¦": "H",
                    "â±§": "H",
                    "â±µ": "H",
                    "êž": "H",
                    "â’¾": "I",
                    "ï¼©": "I",
                    "ÃŒ": "I",
                    "Ã": "I",
                    "ÃŽ": "I",
                    "Ä¨": "I",
                    "Äª": "I",
                    "Ä¬": "I",
                    "Ä°": "I",
                    "Ã": "I",
                    "á¸®": "I",
                    "á»ˆ": "I",
                    "Ç": "I",
                    "Èˆ": "I",
                    "ÈŠ": "I",
                    "á»Š": "I",
                    "Ä®": "I",
                    "á¸¬": "I",
                    "Æ—": "I",
                    "â’¿": "J",
                    "ï¼ª": "J",
                    "Ä´": "J",
                    "Éˆ": "J",
                    "â“€": "K",
                    "ï¼«": "K",
                    "á¸°": "K",
                    "Ç¨": "K",
                    "á¸²": "K",
                    "Ä¶": "K",
                    "á¸´": "K",
                    "Æ˜": "K",
                    "â±©": "K",
                    "ê€": "K",
                    "ê‚": "K",
                    "ê„": "K",
                    "êž¢": "K",
                    "â“": "L",
                    "ï¼¬": "L",
                    "Ä¿": "L",
                    "Ä¹": "L",
                    "Ä½": "L",
                    "á¸¶": "L",
                    "á¸¸": "L",
                    "Ä»": "L",
                    "á¸¼": "L",
                    "á¸º": "L",
                    "Å": "L",
                    "È½": "L",
                    "â±¢": "L",
                    "ï¿½ï¿½ ": "L",
                    "êˆ": "L",
                    "ê†": "L",
                    "êž€": "L",
                    "Ç‡": "LJ",
                    "Çˆ": "Lj",
                    "â“‚": "M",
                    "ï¼­": "M",
                    "á¸¾": "M",
                    "á¹€": "M",
                    "á¹‚": "M",
                    "â±®": "M",
                    "Æœ": "M",
                    "â“ƒ": "N",
                    "ï¼®": "N",
                    "Ç¸": "N",
                    "Åƒ": "N",
                    "Ã‘": "N",
                    "á¹„": "N",
                    "Å‡": "N",
                    "á¹†": "N",
                    "Å…": "N",
                    "á¹Š": "N",
                    "á¹ˆ": "N",
                    "ï¿½ ": "N",
                    "Æ": "N",
                    "êž": "N",
                    "êž¤": "N",
                    "ÇŠ": "NJ",
                    "Ç‹": "Nj",
                    "â“„": "O",
                    "ï¼¯": "O",
                    "Ã’": "O",
                    "Ã“": "O",
                    "Ã”": "O",
                    "á»’": "O",
                    "á»": "O",
                    "á»–": "O",
                    "á»”": "O",
                    "Ã•": "O",
                    "á¹Œ": "O",
                    "È¬": "O",
                    "á¹Ž": "O",
                    "ÅŒ": "O",
                    "á¹": "O",
                    "á¹’": "O",
                    "ÅŽ": "O",
                    "È®": "O",
                    "È°": "O",
                    "Ã–": "O",
                    "Èª": "O",
                    "á»Ž": "O",
                    "Å": "O",
                    "Ç‘": "O",
                    "ÈŒ": "O",
                    "ÈŽ": "O",
                    "ï¿½ ": "O",
                    "á»œ": "O",
                    "á»š": "O",
                    "ï¿½ï¿½ ": "O",
                    "á»ž": "O",
                    "á»¢": "O",
                    "á»Œ": "O",
                    "á»˜": "O",
                    "Çª": "O",
                    "Ç¬": "O",
                    "Ã˜": "O",
                    "Ç¾": "O",
                    "Æ†": "O",
                    "ÆŸ": "O",
                    "êŠ": "O",
                    "êŒ": "O",
                    "Æ¢": "OI",
                    "êŽ": "OO",
                    "È¢": "OU",
                    "â“…": "P",
                    "ï¼°": "P",
                    "á¹”": "P",
                    "á¹–": "P",
                    "Æ¤": "P",
                    "â±£": "P",
                    "ê": "P",
                    "ê’": "P",
                    "ê”": "P",
                    "â“†": "Q",
                    "ï¼±": "Q",
                    "ê–": "Q",
                    "ê˜": "Q",
                    "ÉŠ": "Q",
                    "â“‡": "R",
                    "ï¼²": "R",
                    "Å”": "R",
                    "á¹˜": "R",
                    "Å˜": "R",
                    "È": "R",
                    "È’": "R",
                    "á¹š": "R",
                    "á¹œ": "R",
                    "Å–": "R",
                    "á¹ž": "R",
                    "ÉŒ": "R",
                    "â±¤": "R",
                    "êš": "R",
                    "êž¦": "R",
                    "êž‚": "R",
                    "â“ˆ": "S",
                    "ï¼³": "S",
                    "áºž": "S",
                    "Åš": "S",
                    "á¹¤": "S",
                    "Åœ": "S",
                    "ï¿½ï¿½ ": "S",
                    "ï¿½ ": "S",
                    "á¹¦": "S",
                    "á¹¢": "S",
                    "á¹¨": "S",
                    "È˜": "S",
                    "Åž": "S",
                    "â±¾": "S",
                    "êž¨": "S",
                    "êž„": "S",
                    "â“‰": "T",
                    "ï¼´": "T",
                    "á¹ª": "T",
                    "Å¤": "T",
                    "á¹¬": "T",
                    "Èš": "T",
                    "Å¢": "T",
                    "á¹°": "T",
                    "á¹®": "T",
                    "Å¦": "T",
                    "Æ¬": "T",
                    "Æ®": "T",
                    "È¾": "T",
                    "êž†": "T",
                    "êœ¨": "TZ",
                    "â“Š": "U",
                    "ï¼µ": "U",
                    "Ã™": "U",
                    "Ãš": "U",
                    "Ã›": "U",
                    "Å¨": "U",
                    "á¹¸": "U",
                    "Åª": "U",
                    "á¹º": "U",
                    "Å¬": "U",
                    "Ãœ": "U",
                    "Ç›": "U",
                    "Ç—": "U",
                    "Ç•": "U",
                    "Ç™": "U",
                    "á»¦": "U",
                    "Å®": "U",
                    "Å°": "U",
                    "Ç“": "U",
                    "È”": "U",
                    "È–": "U",
                    "Æ¯": "U",
                    "á»ª": "U",
                    "á»¨": "U",
                    "á»®": "U",
                    "á»¬": "U",
                    "á»°": "U",
                    "á»¤": "U",
                    "á¹²": "U",
                    "Å²": "U",
                    "á¹¶": "U",
                    "á¹´": "U",
                    "É„": "U",
                    "â“‹": "V",
                    "ï¼¶": "V",
                    "á¹¼": "V",
                    "á¹¾": "V",
                    "Æ²": "V",
                    "êž": "V",
                    "É…": "V",
                    "ï¿½ï¿½ ": "VY",
                    "â“Œ": "W",
                    "ï¼·": "W",
                    "áº€": "W",
                    "áº‚": "W",
                    "Å´": "W",
                    "áº†": "W",
                    "áº„": "W",
                    "áºˆ": "W",
                    "â±²": "W",
                    "â“": "X",
                    "ï¼¸": "X",
                    "áºŠ": "X",
                    "áºŒ": "X",
                    "â“Ž": "Y",
                    "ï¼¹": "Y",
                    "á»²": "Y",
                    "Ã": "Y",
                    "Å¶": "Y",
                    "á»¸": "Y",
                    "È²": "Y",
                    "áºŽ": "Y",
                    "Å¸": "Y",
                    "á»¶": "Y",
                    "á»´": "Y",
                    "Æ³": "Y",
                    "ÉŽ": "Y",
                    "á»¾": "Y",
                    "â“": "Z",
                    "ï¼º": "Z",
                    "Å¹": "Z",
                    "áº": "Z",
                    "Å»": "Z",
                    "Å½": "Z",
                    "áº’": "Z",
                    "áº”": "Z",
                    "Æµ": "Z",
                    "È¤": "Z",
                    "â±¿": "Z",
                    "â±«": "Z",
                    "ê¢": "Z",
                    "â“": "a",
                    "ï½": "a",
                    "áºš": "a",
                    "ï¿½ ": "a",
                    "Ã¡": "a",
                    "Ã¢": "a",
                    "áº§": "a",
                    "áº¥": "a",
                    "áº«": "a",
                    "áº©": "a",
                    "Ã£": "a",
                    "Ä": "a",
                    "Äƒ": "a",
                    "áº±": "a",
                    "áº¯": "a",
                    "áºµ": "a",
                    "áº³": "a",
                    "È§": "a",
                    "Ç¡": "a",
                    "Ã¤": "a",
                    "ÇŸ": "a",
                    "áº£": "a",
                    "Ã¥": "a",
                    "Ç»": "a",
                    "ÇŽ": "a",
                    "È": "a",
                    "Èƒ": "a",
                    "áº¡": "a",
                    "áº­": "a",
                    "áº·": "a",
                    "á¸": "a",
                    "Ä…": "a",
                    "â±¥": "a",
                    "É": "a",
                    "êœ³": "aa",
                    "Ã¦": "ae",
                    "Ç½": "ae",
                    "Ç£": "ae",
                    "êœµ": "ao",
                    "êœ·": "au",
                    "êœ¹": "av",
                    "êœ»": "av",
                    "êœ½": "ay",
                    "â“‘": "b",
                    "ï½‚": "b",
                    "á¸ƒ": "b",
                    "á¸…": "b",
                    "á¸‡": "b",
                    "Æ€": "b",
                    "Æƒ": "b",
                    "É“": "b",
                    "â“’": "c",
                    "ï½ƒ": "c",
                    "Ä‡": "c",
                    "Ä‰": "c",
                    "Ä‹": "c",
                    "Ä": "c",
                    "Ã§": "c",
                    "á¸‰": "c",
                    "Æˆ": "c",
                    "È¼": "c",
                    "êœ¿": "c",
                    "â†„": "c",
                    "â““": "d",
                    "ï½„": "d",
                    "á¸‹": "d",
                    "Ä": "d",
                    "á¸": "d",
                    "á¸‘": "d",
                    "á¸“": "d",
                    "á¸": "d",
                    "Ä‘": "d",
                    "ÆŒ": "d",
                    "É–": "d",
                    "É—": "d",
                    "êº": "d",
                    "Ç³": "dz",
                    "Ç†": "dz",
                    "â“”": "e",
                    "ï½…": "e",
                    "Ã¨": "e",
                    "Ã©": "e",
                    "Ãª": "e",
                    "á»": "e",
                    "áº¿": "e",
                    "á»…": "e",
                    "á»ƒ": "e",
                    "áº½": "e",
                    "Ä“": "e",
                    "á¸•": "e",
                    "á¸—": "e",
                    "Ä•": "e",
                    "Ä—": "e",
                    "Ã«": "e",
                    "áº»": "e",
                    "Ä›": "e",
                    "È…": "e",
                    "È‡": "e",
                    "áº¹": "e",
                    "á»‡": "e",
                    "È©": "e",
                    "á¸": "e",
                    "Ä™": "e",
                    "á¸™": "e",
                    "á¸›": "e",
                    "É‡": "e",
                    "É›": "e",
                    "Ç": "e",
                    "â“•": "f",
                    "ï½†": "f",
                    "á¸Ÿ": "f",
                    "Æ’": "f",
                    "ê¼": "f",
                    "â“–": "g",
                    "ï½‡": "g",
                    "Çµ": "g",
                    "Ä": "g",
                    "á¸¡": "g",
                    "ÄŸ": "g",
                    "Ä¡": "g",
                    "Ç§": "g",
                    "Ä£": "g",
                    "Ç¥": "g",
                    "ï¿½ ": "g",
                    "êž¡": "g",
                    "áµ¹": "g",
                    "ê¿": "g",
                    "â“—": "h",
                    "ï½ˆ": "h",
                    "Ä¥": "h",
                    "á¸£": "h",
                    "á¸§": "h",
                    "ÈŸ": "h",
                    "á¸¥": "h",
                    "á¸©": "h",
                    "á¸«": "h",
                    "áº–": "h",
                    "Ä§": "h",
                    "â±¨": "h",
                    "â±¶": "h",
                    "É¥": "h",
                    "Æ•": "hv",
                    "â“˜": "i",
                    "ï½‰": "i",
                    "Ã¬": "i",
                    "Ã­": "i",
                    "Ã®": "i",
                    "Ä©": "i",
                    "Ä«": "i",
                    "Ä­": "i",
                    "Ã¯": "i",
                    "á¸¯": "i",
                    "á»‰": "i",
                    "Ç": "i",
                    "È‰": "i",
                    "È‹": "i",
                    "á»‹": "i",
                    "Ä¯": "i",
                    "á¸­": "i",
                    "É¨": "i",
                    "Ä±": "i",
                    "â“™": "j",
                    "ï½Š": "j",
                    "Äµ": "j",
                    "Ç°": "j",
                    "É‰": "j",
                    "â“š": "k",
                    "ï½‹": "k",
                    "á¸±": "k",
                    "Ç©": "k",
                    "á¸³": "k",
                    "Ä·": "k",
                    "á¸µ": "k",
                    "Æ™": "k",
                    "â±ª": "k",
                    "ê": "k",
                    "êƒ": "k",
                    "ê…": "k",
                    "êž£": "k",
                    "â“›": "l",
                    "ï½Œ": "l",
                    "Å€": "l",
                    "Äº": "l",
                    "Ä¾": "l",
                    "á¸·": "l",
                    "á¸¹": "l",
                    "Ä¼": "l",
                    "á¸½": "l",
                    "á¸»": "l",
                    "Å¿": "l",
                    "Å‚": "l",
                    "Æš": "l",
                    "É«": "l",
                    "â±¡": "l",
                    "ê‰": "l",
                    "êž": "l",
                    "ê‡": "l",
                    "Ç‰": "lj",
                    "â“œ": "m",
                    "ï½": "m",
                    "á¸¿": "m",
                    "á¹": "m",
                    "á¹ƒ": "m",
                    "É±": "m",
                    "É¯": "m",
                    "â“": "n",
                    "ï½Ž": "n",
                    "Ç¹": "n",
                    "Å„": "n",
                    "Ã±": "n",
                    "á¹…": "n",
                    "Åˆ": "n",
                    "á¹‡": "n",
                    "Å†": "n",
                    "á¹‹": "n",
                    "á¹‰": "n",
                    "Æž": "n",
                    "É²": "n",
                    "Å‰": "n",
                    "êž‘": "n",
                    "êž¥": "n",
                    "ÇŒ": "nj",
                    "â“ž": "o",
                    "ï½": "o",
                    "Ã²": "o",
                    "Ã³": "o",
                    "Ã´": "o",
                    "á»“": "o",
                    "á»‘": "o",
                    "á»—": "o",
                    "á»•": "o",
                    "Ãµ": "o",
                    "á¹": "o",
                    "È­": "o",
                    "á¹": "o",
                    "Å": "o",
                    "á¹‘": "o",
                    "á¹“": "o",
                    "Å": "o",
                    "È¯": "o",
                    "È±": "o",
                    "Ã¶": "o",
                    "È«": "o",
                    "á»": "o",
                    "Å‘": "o",
                    "Ç’": "o",
                    "È": "o",
                    "È": "o",
                    "Æ¡": "o",
                    "á»": "o",
                    "á»›": "o",
                    "á»¡": "o",
                    "á»Ÿ": "o",
                    "á»£": "o",
                    "á»": "o",
                    "á»™": "o",
                    "Ç«": "o",
                    "Ç­": "o",
                    "Ã¸": "o",
                    "Ç¿": "o",
                    "É”": "o",
                    "ê‹": "o",
                    "ê": "o",
                    "Éµ": "o",
                    "Æ£": "oi",
                    "È£": "ou",
                    "ê": "oo",
                    "â“Ÿ": "p",
                    "ï½": "p",
                    "á¹•": "p",
                    "á¹—": "p",
                    "Æ¥": "p",
                    "áµ½": "p",
                    "ê‘": "p",
                    "ê“": "p",
                    "ê•": "p",
                    "ï¿½ï¿½ ": "q",
                    "ï½‘": "q",
                    "É‹": "q",
                    "ê—": "q",
                    "ê™": "q",
                    "â“¡": "r",
                    "ï½’": "r",
                    "Å•": "r",
                    "á¹™": "r",
                    "Å™": "r",
                    "È‘": "r",
                    "È“": "r",
                    "á¹›": "r",
                    "á¹": "r",
                    "Å—": "r",
                    "á¹Ÿ": "r",
                    "É": "r",
                    "É½": "r",
                    "ê›": "r",
                    "êž§": "r",
                    "êžƒ": "r",
                    "â“¢": "s",
                    "ï½“": "s",
                    "ÃŸ": "s",
                    "Å›": "s",
                    "á¹¥": "s",
                    "Å": "s",
                    "á¹¡": "s",
                    "Å¡": "s",
                    "á¹§": "s",
                    "á¹£": "s",
                    "á¹©": "s",
                    "È™": "s",
                    "ÅŸ": "s",
                    "È¿": "s",
                    "êž©": "s",
                    "êž…": "s",
                    "áº›": "s",
                    "â“£": "t",
                    "ï½”": "t",
                    "á¹«": "t",
                    "áº—": "t",
                    "Å¥": "t",
                    "á¹­": "t",
                    "È›": "t",
                    "Å£": "t",
                    "á¹±": "t",
                    "á¹¯": "t",
                    "Å§": "t",
                    "Æ­": "t",
                    "Êˆ": "t",
                    "â±¦": "t",
                    "êž‡": "t",
                    "êœ©": "tz",
                    "â“¤": "u",
                    "ï½•": "u",
                    "Ã¹": "u",
                    "Ãº": "u",
                    "Ã»": "u",
                    "Å©": "u",
                    "á¹¹": "u",
                    "Å«": "u",
                    "á¹»": "u",
                    "Å­": "u",
                    "Ã¼": "u",
                    "Çœ": "u",
                    "Ç˜": "u",
                    "Ç–": "u",
                    "Çš": "u",
                    "á»§": "u",
                    "Å¯": "u",
                    "Å±": "u",
                    "Ç”": "u",
                    "È•": "u",
                    "È—": "u",
                    "Æ°": "u",
                    "á»«": "u",
                    "á»©": "u",
                    "á»¯": "u",
                    "á»­": "u",
                    "á»±": "u",
                    "á»¥": "u",
                    "á¹³": "u",
                    "Å³": "u",
                    "á¹·": "u",
                    "á¹µ": "u",
                    "Ê‰": "u",
                    "â“¥": "v",
                    "ï½–": "v",
                    "á¹½": "v",
                    "á¹¿": "v",
                    "Ê‹": "v",
                    "êŸ": "v",
                    "ÊŒ": "v",
                    "ê¡": "vy",
                    "â“¦": "w",
                    "ï½—": "w",
                    "áº": "w",
                    "áºƒ": "w",
                    "Åµ": "w",
                    "áº‡": "w",
                    "áº…": "w",
                    "áº˜": "w",
                    "áº‰": "w",
                    "â±³": "w",
                    "â“§": "x",
                    "ï½˜": "x",
                    "áº‹": "x",
                    "áº": "x",
                    "â“¨": "y",
                    "ï½™": "y",
                    "á»³": "y",
                    "Ã½": "y",
                    "Å·": "y",
                    "á»¹": "y",
                    "È³": "y",
                    "áº": "y",
                    "Ã¿": "y",
                    "á»·": "y",
                    "áº™": "y",
                    "á»µ": "y",
                    "Æ´": "y",
                    "É": "y",
                    "á»¿": "y",
                    "â“©": "z",
                    "ï½š": "z",
                    "Åº": "z",
                    "áº‘": "z",
                    "Å¼": "z",
                    "Å¾": "z",
                    "áº“": "z",
                    "áº•": "z",
                    "Æ¶": "z",
                    "È¥": "z",
                    "É€": "z",
                    "â±¬": "z",
                    "ê£": "z",
                    "Î†": "Î‘",
                    "Îˆ": "Î•",
                    "Î‰": "Î—",
                    "ÎŠ": "Î™",
                    "Îª": "Î™",
                    "ÎŒ": "ÎŸ",
                    "ÎŽ": "Î¥",
                    "Î«": "Î¥",
                    "Î": "Î©",
                    "Î¬": "Î±",
                    "Î­": "Îµ",
                    "Î®": "Î·",
                    "Î¯": "Î¹",
                    "ÏŠ": "Î¹",
                    "Î": "Î¹",
                    "ÏŒ": "Î¿",
                    "Ï": "Ï…",
                    "Ï‹": "Ï…",
                    "Î°": "Ï…",
                    "Ï‰": "Ï‰",
                    "Ï‚": "Ïƒ"
                }
            }), e.define("select2/data/base", ["../utils"], function(t) {
                function e(t, n) {
                    e.__super__.constructor.call(this)
                }
                return t.Extend(e, t.Observable), e.prototype.current = function(t) {
                    throw new Error("The `current` method must be defined in child classes.")
                }, e.prototype.query = function(t, e) {
                    throw new Error("The `query` method must be defined in child classes.")
                }, e.prototype.bind = function(t, e) {}, e.prototype.destroy = function() {}, e.prototype.generateResultId = function(e, n) {
                    var i = e.id + "-result-";
                    return i += t.generateChars(4), null != n.id ? i += "-" + n.id.toString() : i += "-" + t.generateChars(4), i
                }, e
            }), e.define("select2/data/select", ["./base", "../utils", "jquery"], function(t, e, n) {
                function i(t, e) {
                    this.$element = t, this.options = e, i.__super__.constructor.call(this)
                }
                return e.Extend(i, t), i.prototype.current = function(t) {
                    var e = [],
                        i = this;
                    this.$element.find(":selected").each(function() {
                        var t = n(this),
                            o = i.item(t);
                        e.push(o)
                    }), t(e)
                }, i.prototype.select = function(t) {
                    var e = this;
                    if (t.selected = !0, n(t.element).is("option")) return t.element.selected = !0, void this.$element.trigger("change");
                    if (this.$element.prop("multiple")) this.current(function(i) {
                        var o = [];
                        t = [t], t.push.apply(t, i);
                        for (var s = 0; s < t.length; s++) {
                            var r = t[s].id; - 1 === n.inArray(r, o) && o.push(r)
                        }
                        e.$element.val(o), e.$element.trigger("change")
                    });
                    else {
                        var i = t.id;
                        this.$element.val(i), this.$element.trigger("change")
                    }
                }, i.prototype.unselect = function(t) {
                    var e = this;
                    if (this.$element.prop("multiple")) {
                        if (t.selected = !1, n(t.element).is("option")) return t.element.selected = !1, void this.$element.trigger("change");
                        this.current(function(i) {
                            for (var o = [], s = 0; s < i.length; s++) {
                                var r = i[s].id;
                                r !== t.id && -1 === n.inArray(r, o) && o.push(r)
                            }
                            e.$element.val(o), e.$element.trigger("change")
                        })
                    }
                }, i.prototype.bind = function(t, e) {
                    var n = this;
                    this.container = t, t.on("select", function(t) {
                        n.select(t.data)
                    }), t.on("unselect", function(t) {
                        n.unselect(t.data)
                    })
                }, i.prototype.destroy = function() {
                    this.$element.find("*").each(function() {
                        n.removeData(this, "data")
                    })
                }, i.prototype.query = function(t, e) {
                    var i = [],
                        o = this;
                    this.$element.children().each(function() {
                        var e = n(this);
                        if (e.is("option") || e.is("optgroup")) {
                            var s = o.item(e),
                                r = o.matches(t, s);
                            null !== r && i.push(r)
                        }
                    }), e({
                        results: i
                    })
                }, i.prototype.addOptions = function(t) {
                    e.appendMany(this.$element, t)
                }, i.prototype.option = function(t) {
                    var e;
                    t.children ? (e = document.createElement("optgroup"), e.label = t.text) : (e = document.createElement("option"), void 0 !== e.textContent ? e.textContent = t.text : e.innerText = t.text), void 0 !== t.id && (e.value = t.id), t.disabled && (e.disabled = !0), t.selected && (e.selected = !0), t.title && (e.title = t.title);
                    var i = n(e),
                        o = this._normalizeItem(t);
                    return o.element = e, n.data(e, "data", o), i
                }, i.prototype.item = function(t) {
                    var e = {};
                    if (null != (e = n.data(t[0], "data"))) return e;
                    if (t.is("option")) e = {
                        id: t.val(),
                        text: t.text(),
                        disabled: t.prop("disabled"),
                        selected: t.prop("selected"),
                        title: t.prop("title")
                    };
                    else if (t.is("optgroup")) {
                        e = {
                            text: t.prop("label"),
                            children: [],
                            title: t.prop("title")
                        };
                        for (var i = t.children("option"), o = [], s = 0; s < i.length; s++) {
                            var r = n(i[s]),
                                a = this.item(r);
                            o.push(a)
                        }
                        e.children = o
                    }
                    return e = this._normalizeItem(e), e.element = t[0], n.data(t[0], "data", e), e
                }, i.prototype._normalizeItem = function(t) {
                    n.isPlainObject(t) || (t = {
                        id: t,
                        text: t
                    }), t = n.extend({}, {
                        text: ""
                    }, t);
                    var e = {
                        selected: !1,
                        disabled: !1
                    };
                    return null != t.id && (t.id = t.id.toString()), null != t.text && (t.text = t.text.toString()), null == t._resultId && t.id && null != this.container && (t._resultId = this.generateResultId(this.container, t)), n.extend({}, e, t)
                }, i.prototype.matches = function(t, e) {
                    return this.options.get("matcher")(t, e)
                }, i
            }), e.define("select2/data/array", ["./select", "../utils", "jquery"], function(t, e, n) {
                function i(t, e) {
                    var n = e.get("data") || [];
                    i.__super__.constructor.call(this, t, e), this.addOptions(this.convertToOptions(n))
                }
                return e.Extend(i, t), i.prototype.select = function(t) {
                    var e = this.$element.find("option").filter(function(e, n) {
                        return n.value == t.id.toString()
                    });
                    0 === e.length && (e = this.option(t), this.addOptions(e)), i.__super__.select.call(this, t)
                }, i.prototype.convertToOptions = function(t) {
                    for (var i = this, o = this.$element.find("option"), s = o.map(function() {
                            return i.item(n(this)).id
                        }).get(), r = [], a = 0; a < t.length; a++) {
                        var l = this._normalizeItem(t[a]);
                        if (n.inArray(l.id, s) >= 0) {
                            var c = o.filter(function(t) {
                                    return function() {
                                        return n(this).val() == t.id
                                    }
                                }(l)),
                                d = this.item(c),
                                u = n.extend(!0, {}, l, d),
                                p = this.option(u);
                            c.replaceWith(p)
                        } else {
                            var h = this.option(l);
                            if (l.children) {
                                var f = this.convertToOptions(l.children);
                                e.appendMany(h, f)
                            }
                            r.push(h)
                        }
                    }
                    return r
                }, i
            }), e.define("select2/data/ajax", ["./array", "../utils", "jquery"], function(t, e, n) {
                function i(t, e) {
                    this.ajaxOptions = this._applyDefaults(e.get("ajax")), null != this.ajaxOptions.processResults && (this.processResults = this.ajaxOptions.processResults), i.__super__.constructor.call(this, t, e)
                }
                return e.Extend(i, t), i.prototype._applyDefaults = function(t) {
                    var e = {
                        data: function(t) {
                            return n.extend({}, t, {
                                q: t.term
                            })
                        },
                        transport: function(t, e, i) {
                            var o = n.ajax(t);
                            return o.then(e), o.fail(i), o
                        }
                    };
                    return n.extend({}, e, t, !0)
                }, i.prototype.processResults = function(t) {
                    return t
                }, i.prototype.query = function(t, e) {
                    function i() {
                        var i = s.transport(s, function(i) {
                            var s = o.processResults(i, t);
                            o.options.get("debug") && window.console && console.error && (s && s.results && n.isArray(s.results) || console.error("Select2: The AJAX results did not return an array in the `results` key of the response.")), e(s)
                        }, function() {
                            i.status && "0" === i.status || o.trigger("results:message", {
                                message: "errorLoading"
                            })
                        });
                        o._request = i
                    }
                    var o = this;
                    null != this._request && (n.isFunction(this._request.abort) && this._request.abort(), this._request = null);
                    var s = n.extend({
                        type: "GET"
                    }, this.ajaxOptions);
                    "function" == typeof s.url && (s.url = s.url.call(this.$element, t)), "function" == typeof s.data && (s.data = s.data.call(this.$element, t)), this.ajaxOptions.delay && null != t.term ? (this._queryTimeout && window.clearTimeout(this._queryTimeout), this._queryTimeout = window.setTimeout(i, this.ajaxOptions.delay)) : i()
                }, i
            }), e.define("select2/data/tags", ["jquery"], function(t) {
                function e(e, n, i) {
                    var o = i.get("tags"),
                        s = i.get("createTag");
                    void 0 !== s && (this.createTag = s);
                    var r = i.get("insertTag");
                    if (void 0 !== r && (this.insertTag = r), e.call(this, n, i), t.isArray(o))
                        for (var a = 0; a < o.length; a++) {
                            var l = o[a],
                                c = this._normalizeItem(l),
                                d = this.option(c);
                            this.$element.append(d)
                        }
                }
                return e.prototype.query = function(t, e, n) {
                    function i(t, s) {
                        for (var r = t.results, a = 0; a < r.length; a++) {
                            var l = r[a],
                                c = null != l.children && !i({
                                    results: l.children
                                }, !0);
                            if ((l.text || "").toUpperCase() === (e.term || "").toUpperCase() || c) return !s && (t.data = r, void n(t))
                        }
                        if (s) return !0;
                        var d = o.createTag(e);
                        if (null != d) {
                            var u = o.option(d);
                            u.attr("data-select2-tag", !0), o.addOptions([u]), o.insertTag(r, d)
                        }
                        t.results = r, n(t)
                    }
                    var o = this;
                    if (this._removeOldTags(), null == e.term || null != e.page) return void t.call(this, e, n);
                    t.call(this, e, i)
                }, e.prototype.createTag = function(e, n) {
                    var i = t.trim(n.term);
                    return "" === i ? null : {
                        id: i,
                        text: i
                    }
                }, e.prototype.insertTag = function(t, e, n) {
                    e.unshift(n)
                }, e.prototype._removeOldTags = function(e) {
                    this._lastTag, this.$element.find("option[data-select2-tag]").each(function() {
                        this.selected || t(this).remove()
                    })
                }, e
            }), e.define("select2/data/tokenizer", ["jquery"], function(t) {
                function e(t, e, n) {
                    var i = n.get("tokenizer");
                    void 0 !== i && (this.tokenizer = i), t.call(this, e, n)
                }
                return e.prototype.bind = function(t, e, n) {
                    t.call(this, e, n), this.$search = e.dropdown.$search || e.selection.$search || n.find(".select2-search__field")
                }, e.prototype.query = function(e, n, i) {
                    function o(e) {
                        var n = r._normalizeItem(e);
                        if (!r.$element.find("option").filter(function() {
                                return t(this).val() === n.id
                            }).length) {
                            var i = r.option(n);
                            i.attr("data-select2-tag", !0), r._removeOldTags(), r.addOptions([i])
                        }
                        s(n)
                    }

                    function s(t) {
                        r.trigger("select", {
                            data: t
                        })
                    }
                    var r = this;
                    n.term = n.term || "";
                    var a = this.tokenizer(n, this.options, o);
                    a.term !== n.term && (this.$search.length && (this.$search.val(a.term), this.$search.focus()), n.term = a.term), e.call(this, n, i)
                }, e.prototype.tokenizer = function(e, n, i, o) {
                    for (var s = i.get("tokenSeparators") || [], r = n.term, a = 0, l = this.createTag || function(t) {
                            return {
                                id: t.term,
                                text: t.term
                            }
                        }; a < r.length;) {
                        var c = r[a];
                        if (-1 !== t.inArray(c, s)) {
                            var d = r.substr(0, a),
                                u = t.extend({}, n, {
                                    term: d
                                }),
                                p = l(u);
                            null != p ? (o(p), r = r.substr(a + 1) || "", a = 0) : a++
                        } else a++
                    }
                    return {
                        term: r
                    }
                }, e
            }), e.define("select2/data/minimumInputLength", [], function() {
                function t(t, e, n) {
                    this.minimumInputLength = n.get("minimumInputLength"), t.call(this, e, n)
                }
                return t.prototype.query = function(t, e, n) {
                    if (e.term = e.term || "", e.term.length < this.minimumInputLength) return void this.trigger("results:message", {
                        message: "inputTooShort",
                        args: {
                            minimum: this.minimumInputLength,
                            input: e.term,
                            params: e
                        }
                    });
                    t.call(this, e, n)
                }, t
            }), e.define("select2/data/maximumInputLength", [], function() {
                function t(t, e, n) {
                    this.maximumInputLength = n.get("maximumInputLength"), t.call(this, e, n)
                }
                return t.prototype.query = function(t, e, n) {
                    if (e.term = e.term || "", this.maximumInputLength > 0 && e.term.length > this.maximumInputLength) return void this.trigger("results:message", {
                        message: "inputTooLong",
                        args: {
                            maximum: this.maximumInputLength,
                            input: e.term,
                            params: e
                        }
                    });
                    t.call(this, e, n)
                }, t
            }), e.define("select2/data/maximumSelectionLength", [], function() {
                function t(t, e, n) {
                    this.maximumSelectionLength = n.get("maximumSelectionLength"), t.call(this, e, n)
                }
                return t.prototype.query = function(t, e, n) {
                    var i = this;
                    this.current(function(o) {
                        var s = null != o ? o.length : 0;
                        if (i.maximumSelectionLength > 0 && s >= i.maximumSelectionLength) return void i.trigger("results:message", {
                            message: "maximumSelected",
                            args: {
                                maximum: i.maximumSelectionLength
                            }
                        });
                        t.call(i, e, n)
                    })
                }, t
            }), e.define("select2/dropdown", ["jquery", "./utils"], function(t, e) {
                function n(t, e) {
                    this.$element = t, this.options = e, n.__super__.constructor.call(this)
                }
                return e.Extend(n, e.Observable), n.prototype.render = function() {
                    var e = t('<span class="select2-dropdown"><span class="select2-results"></span></span>');
                    return e.attr("dir", this.options.get("dir")), this.$dropdown = e, e
                }, n.prototype.bind = function() {}, n.prototype.position = function(t, e) {}, n.prototype.destroy = function() {
                    this.$dropdown.remove()
                }, n
            }), e.define("select2/dropdown/search", ["jquery", "../utils"], function(t, e) {
                function n() {}
                return n.prototype.render = function(e) {
                    var n = e.call(this),
                        i = t('<span class="select2-search select2-search--dropdown"><input class="select2-search__field" type="search" tabindex="-1" autocomplete="off" autocorrect="off" autocapitalize="none" spellcheck="false" role="textbox" /></span>');
                    return this.$searchContainer = i, this.$search = i.find("input"), n.prepend(i), n
                }, n.prototype.bind = function(e, n, i) {
                    var o = this;
                    e.call(this, n, i), this.$search.on("keydown", function(t) {
                        o.trigger("keypress", t), o._keyUpPrevented = t.isDefaultPrevented()
                    }), this.$search.on("input", function(e) {
                        t(this).off("keyup")
                    }), this.$search.on("keyup input", function(t) {
                        o.handleSearch(t)
                    }), n.on("open", function() {
                        o.$search.attr("tabindex", 0), o.$search.focus(), window.setTimeout(function() {
                            o.$search.focus()
                        }, 0)
                    }), n.on("close", function() {
                        o.$search.attr("tabindex", -1), o.$search.val("")
                    }), n.on("focus", function() {
                        n.isOpen() || o.$search.focus()
                    }), n.on("results:all", function(t) {
                        null != t.query.term && "" !== t.query.term || (o.showSearch(t) ? o.$searchContainer.removeClass("select2-search--hide") : o.$searchContainer.addClass("select2-search--hide"))
                    })
                }, n.prototype.handleSearch = function(t) {
                    if (!this._keyUpPrevented) {
                        var e = this.$search.val();
                        this.trigger("query", {
                            term: e
                        })
                    }
                    this._keyUpPrevented = !1
                }, n.prototype.showSearch = function(t, e) {
                    return !0
                }, n
            }), e.define("select2/dropdown/hidePlaceholder", [], function() {
                function t(t, e, n, i) {
                    this.placeholder = this.normalizePlaceholder(n.get("placeholder")), t.call(this, e, n, i)
                }
                return t.prototype.append = function(t, e) {
                    e.results = this.removePlaceholder(e.results), t.call(this, e)
                }, t.prototype.normalizePlaceholder = function(t, e) {
                    return "string" == typeof e && (e = {
                        id: "",
                        text: e
                    }), e
                }, t.prototype.removePlaceholder = function(t, e) {
                    for (var n = e.slice(0), i = e.length - 1; i >= 0; i--) {
                        var o = e[i];
                        this.placeholder.id === o.id && n.splice(i, 1)
                    }
                    return n
                }, t
            }), e.define("select2/dropdown/infiniteScroll", ["jquery"], function(t) {
                function e(t, e, n, i) {
                    this.lastParams = {}, t.call(this, e, n, i), this.$loadingMore = this.createLoadingMore(), this.loading = !1
                }
                return e.prototype.append = function(t, e) {
                    this.$loadingMore.remove(), this.loading = !1, t.call(this, e), this.showLoadingMore(e) && this.$results.append(this.$loadingMore)
                }, e.prototype.bind = function(e, n, i) {
                    var o = this;
                    e.call(this, n, i), n.on("query", function(t) {
                        o.lastParams = t, o.loading = !0
                    }), n.on("query:append", function(t) {
                        o.lastParams = t, o.loading = !0
                    }), this.$results.on("scroll", function() {
                        var e = t.contains(document.documentElement, o.$loadingMore[0]);
                        !o.loading && e && o.$results.offset().top + o.$results.outerHeight(!1) + 50 >= o.$loadingMore.offset().top + o.$loadingMore.outerHeight(!1) && o.loadMore()
                    })
                }, e.prototype.loadMore = function() {
                    this.loading = !0;
                    var e = t.extend({}, {
                        page: 1
                    }, this.lastParams);
                    e.page++, this.trigger("query:append", e)
                }, e.prototype.showLoadingMore = function(t, e) {
                    return e.pagination && e.pagination.more
                }, e.prototype.createLoadingMore = function() {
                    var e = t('<li class="select2-results__option select2-results__option--load-more"role="treeitem" aria-disabled="true"></li>'),
                        n = this.options.get("translations").get("loadingMore");
                    return e.html(n(this.lastParams)), e
                }, e
            }), e.define("select2/dropdown/attachBody", ["jquery", "../utils"], function(t, e) {
                function n(e, n, i) {
                    this.$dropdownParent = i.get("dropdownParent") || t(document.body), e.call(this, n, i)
                }
                return n.prototype.bind = function(t, e, n) {
                    var i = this,
                        o = !1;
                    t.call(this, e, n), e.on("open", function() {
                        i._showDropdown(), i._attachPositioningHandler(e), o || (o = !0, e.on("results:all", function() {
                            i._positionDropdown(), i._resizeDropdown()
                        }), e.on("results:append", function() {
                            i._positionDropdown(), i._resizeDropdown()
                        }))
                    }), e.on("close", function() {
                        i._hideDropdown(), i._detachPositioningHandler(e)
                    }), this.$dropdownContainer.on("mousedown", function(t) {
                        t.stopPropagation()
                    })
                }, n.prototype.destroy = function(t) {
                    t.call(this), this.$dropdownContainer.remove()
                }, n.prototype.position = function(t, e, n) {
                    e.attr("class", n.attr("class")), e.removeClass("select2"), e.addClass("select2-container--open"), e.css({
                        position: "absolute",
                        top: -999999
                    }), this.$container = n
                }, n.prototype.render = function(e) {
                    var n = t("<span></span>"),
                        i = e.call(this);
                    return n.append(i), this.$dropdownContainer = n, n
                }, n.prototype._hideDropdown = function(t) {
                    this.$dropdownContainer.detach()
                }, n.prototype._attachPositioningHandler = function(n, i) {
                    var o = this,
                        s = "scroll.select2." + i.id,
                        r = "resize.select2." + i.id,
                        a = "orientationchange.select2." + i.id,
                        l = this.$container.parents().filter(e.hasScroll);
                    l.each(function() {
                        t(this).data("select2-scroll-position", {
                            x: t(this).scrollLeft(),
                            y: t(this).scrollTop()
                        })
                    }), l.on(s, function(e) {
                        var n = t(this).data("select2-scroll-position");
                        t(this).scrollTop(n.y)
                    }), t(window).on(s + " " + r + " " + a, function(t) {
                        o._positionDropdown(), o._resizeDropdown()
                    })
                }, n.prototype._detachPositioningHandler = function(n, i) {
                    var o = "scroll.select2." + i.id,
                        s = "resize.select2." + i.id,
                        r = "orientationchange.select2." + i.id;
                    this.$container.parents().filter(e.hasScroll).off(o), t(window).off(o + " " + s + " " + r)
                }, n.prototype._positionDropdown = function() {
                    var e = t(window),
                        n = this.$dropdown.hasClass("select2-dropdown--above"),
                        i = this.$dropdown.hasClass("select2-dropdown--below"),
                        o = null,
                        s = this.$container.offset();
                    s.bottom = s.top + this.$container.outerHeight(!1);
                    var r = {
                        height: this.$container.outerHeight(!1)
                    };
                    r.top = s.top, r.bottom = s.top + r.height;
                    var a = {
                            height: this.$dropdown.outerHeight(!1)
                        },
                        l = {
                            top: e.scrollTop(),
                            bottom: e.scrollTop() + e.height()
                        },
                        c = l.top < s.top - a.height,
                        d = l.bottom > s.bottom + a.height,
                        u = {
                            left: s.left,
                            top: r.bottom
                        },
                        p = this.$dropdownParent;
                    "static" === p.css("position") && (p = p.offsetParent());
                    var h = p.offset();
                    u.top -= h.top, u.left -= h.left, n || i || (o = "below"), d || !c || n ? !c && d && n && (o = "below") : o = "above", ("above" == o || n && "below" !== o) && (u.top = r.top - h.top - a.height), null != o && (this.$dropdown.removeClass("select2-dropdown--below select2-dropdown--above").addClass("select2-dropdown--" + o), this.$container.removeClass("select2-container--below select2-container--above").addClass("select2-container--" + o)), this.$dropdownContainer.css(u)
                }, n.prototype._resizeDropdown = function() {
                    var t = {
                        width: this.$container.outerWidth(!1) + "px"
                    };
                    this.options.get("dropdownAutoWidth") && (t.minWidth = t.width, t.position = "relative", t.width = "auto"), this.$dropdown.css(t)
                }, n.prototype._showDropdown = function(t) {
                    this.$dropdownContainer.appendTo(this.$dropdownParent), this._positionDropdown(), this._resizeDropdown()
                }, n
            }), e.define("select2/dropdown/minimumResultsForSearch", [], function() {
                function t(e) {
                    for (var n = 0, i = 0; i < e.length; i++) {
                        var o = e[i];
                        o.children ? n += t(o.children) : n++
                    }
                    return n
                }

                function e(t, e, n, i) {
                    this.minimumResultsForSearch = n.get("minimumResultsForSearch"), this.minimumResultsForSearch < 0 && (this.minimumResultsForSearch = 1 / 0), t.call(this, e, n, i)
                }
                return e.prototype.showSearch = function(e, n) {
                    return !(t(n.data.results) < this.minimumResultsForSearch) && e.call(this, n)
                }, e
            }), e.define("select2/dropdown/selectOnClose", [], function() {
                function t() {}
                return t.prototype.bind = function(t, e, n) {
                    var i = this;
                    t.call(this, e, n), e.on("close", function(t) {
                        i._handleSelectOnClose(t)
                    })
                }, t.prototype._handleSelectOnClose = function(t, e) {
                    if (e && null != e.originalSelect2Event) {
                        var n = e.originalSelect2Event;
                        if ("select" === n._type || "unselect" === n._type) return
                    }
                    var i = this.getHighlightedResults();
                    if (!(i.length < 1)) {
                        var o = i.data("data");
                        null != o.element && o.element.selected || null == o.element && o.selected || this.trigger("select", {
                            data: o
                        })
                    }
                }, t
            }), e.define("select2/dropdown/closeOnSelect", [], function() {
                function t() {}
                return t.prototype.bind = function(t, e, n) {
                    var i = this;
                    t.call(this, e, n), e.on("select", function(t) {
                        i._selectTriggered(t)
                    }), e.on("unselect", function(t) {
                        i._selectTriggered(t)
                    })
                }, t.prototype._selectTriggered = function(t, e) {
                    var n = e.originalEvent;
                    n && n.ctrlKey || this.trigger("close", {
                        originalEvent: n,
                        originalSelect2Event: e
                    })
                }, t
            }), e.define("select2/i18n/en", [], function() {
                return {
                    errorLoading: function() {
                        return "The results could not be loaded."
                    },
                    inputTooLong: function(t) {
                        var e = t.input.length - t.maximum,
                            n = "Please delete " + e + " character";
                        return 1 != e && (n += "s"), n
                    },
                    inputTooShort: function(t) {
                        return "Please enter " + (t.minimum - t.input.length) + " or more characters"
                    },
                    loadingMore: function() {
                        return "Loading more resultsâ€¦"
                    },
                    maximumSelected: function(t) {
                        var e = "You can only select " + t.maximum + " item";
                        return 1 != t.maximum && (e += "s"), e
                    },
                    noResults: function() {
                        return "No results found"
                    },
                    searching: function() {
                        return "Searchingâ€¦"
                    }
                }
            }), e.define("select2/defaults", ["jquery", "require", "./results", "./selection/single", "./selection/multiple", "./selection/placeholder", "./selection/allowClear", "./selection/search", "./selection/eventRelay", "./utils", "./translation", "./diacritics", "./data/select", "./data/array", "./data/ajax", "./data/tags", "./data/tokenizer", "./data/minimumInputLength", "./data/maximumInputLength", "./data/maximumSelectionLength", "./dropdown", "./dropdown/search", "./dropdown/hidePlaceholder", "./dropdown/infiniteScroll", "./dropdown/attachBody", "./dropdown/minimumResultsForSearch", "./dropdown/selectOnClose", "./dropdown/closeOnSelect", "./i18n/en"], function(t, e, n, i, o, s, r, a, l, c, d, u, p, h, f, g, m, v, y, b, $, w, _, C, x, A, E, T, S) {
                function D() {
                    this.reset()
                }
                return D.prototype.apply = function(u) {
                    if (u = t.extend(!0, {}, this.defaults, u), null == u.dataAdapter) {
                        if (null != u.ajax ? u.dataAdapter = f : null != u.data ? u.dataAdapter = h : u.dataAdapter = p, u.minimumInputLength > 0 && (u.dataAdapter = c.Decorate(u.dataAdapter, v)), u.maximumInputLength > 0 && (u.dataAdapter = c.Decorate(u.dataAdapter, y)), u.maximumSelectionLength > 0 && (u.dataAdapter = c.Decorate(u.dataAdapter, b)), u.tags && (u.dataAdapter = c.Decorate(u.dataAdapter, g)), null == u.tokenSeparators && null == u.tokenizer || (u.dataAdapter = c.Decorate(u.dataAdapter, m)), null != u.query) {
                            var S = e(u.amdBase + "compat/query");
                            u.dataAdapter = c.Decorate(u.dataAdapter, S)
                        }
                        if (null != u.initSelection) {
                            var D = e(u.amdBase + "compat/initSelection");
                            u.dataAdapter = c.Decorate(u.dataAdapter, D)
                        }
                    }
                    if (null == u.resultsAdapter && (u.resultsAdapter = n, null != u.ajax && (u.resultsAdapter = c.Decorate(u.resultsAdapter, C)), null != u.placeholder && (u.resultsAdapter = c.Decorate(u.resultsAdapter, _)), u.selectOnClose && (u.resultsAdapter = c.Decorate(u.resultsAdapter, E))), null == u.dropdownAdapter) {
                        if (u.multiple) u.dropdownAdapter = $;
                        else {
                            var k = c.Decorate($, w);
                            u.dropdownAdapter = k
                        }
                        if (0 !== u.minimumResultsForSearch && (u.dropdownAdapter = c.Decorate(u.dropdownAdapter, A)), u.closeOnSelect && (u.dropdownAdapter = c.Decorate(u.dropdownAdapter, T)), null != u.dropdownCssClass || null != u.dropdownCss || null != u.adaptDropdownCssClass) {
                            var O = e(u.amdBase + "compat/dropdownCss");
                            u.dropdownAdapter = c.Decorate(u.dropdownAdapter, O)
                        }
                        u.dropdownAdapter = c.Decorate(u.dropdownAdapter, x)
                    }
                    if (null == u.selectionAdapter) {
                        if (u.multiple ? u.selectionAdapter = o : u.selectionAdapter = i, null != u.placeholder && (u.selectionAdapter = c.Decorate(u.selectionAdapter, s)), u.allowClear && (u.selectionAdapter = c.Decorate(u.selectionAdapter, r)), u.multiple && (u.selectionAdapter = c.Decorate(u.selectionAdapter, a)), null != u.containerCssClass || null != u.containerCss || null != u.adaptContainerCssClass) {
                            var j = e(u.amdBase + "compat/containerCss");
                            u.selectionAdapter = c.Decorate(u.selectionAdapter, j)
                        }
                        u.selectionAdapter = c.Decorate(u.selectionAdapter, l)
                    }
                    if ("string" == typeof u.language)
                        if (u.language.indexOf("-") > 0) {
                            var L = u.language.split("-"),
                                P = L[0];
                            u.language = [u.language, P]
                        } else u.language = [u.language];
                    if (t.isArray(u.language)) {
                        var q = new d;
                        u.language.push("en");
                        for (var I = u.language, U = 0; U < I.length; U++) {
                            var R = I[U],
                                H = {};
                            try {
                                H = d.loadPath(R)
                            } catch (t) {
                                try {
                                    R = this.defaults.amdLanguageBase + R, H = d.loadPath(R)
                                } catch (t) {
                                    u.debug && window.console && console.warn && console.warn('Select2: The language file for "' + R + '" could not be automatically loaded. A fallback will be used instead.');
                                    continue
                                }
                            }
                            q.extend(H)
                        }
                        u.translations = q
                    } else {
                        var M = d.loadPath(this.defaults.amdLanguageBase + "en"),
                            z = new d(u.language);
                        z.extend(M), u.translations = z
                    }
                    return u
                }, D.prototype.reset = function() {
                    function e(t) {
                        function e(t) {
                            return u[t] || t
                        }
                        return t.replace(/[^\u0000-\u007E]/g, e)
                    }

                    function n(i, o) {
                        if ("" === t.trim(i.term)) return o;
                        if (o.children && o.children.length > 0) {
                            for (var s = t.extend(!0, {}, o), r = o.children.length - 1; r >= 0; r--) null == n(i, o.children[r]) && s.children.splice(r, 1);
                            return s.children.length > 0 ? s : n(i, s)
                        }
                        var a = e(o.text).toUpperCase(),
                            l = e(i.term).toUpperCase();
                        return a.indexOf(l) > -1 ? o : null
                    }
                    this.defaults = {
                        amdBase: "./",
                        amdLanguageBase: "./i18n/",
                        closeOnSelect: !0,
                        debug: !1,
                        dropdownAutoWidth: !1,
                        escapeMarkup: c.escapeMarkup,
                        language: S,
                        matcher: n,
                        minimumInputLength: 0,
                        maximumInputLength: 0,
                        maximumSelectionLength: 0,
                        minimumResultsForSearch: 0,
                        selectOnClose: !1,
                        sorter: function(t) {
                            return t
                        },
                        templateResult: function(t) {
                            return t.text
                        },
                        templateSelection: function(t) {
                            return t.text
                        },
                        theme: "default",
                        width: "resolve"
                    }
                }, D.prototype.set = function(e, n) {
                    var i = t.camelCase(e),
                        o = {};
                    o[i] = n;
                    var s = c._convertData(o);
                    t.extend(this.defaults, s)
                }, new D
            }), e.define("select2/options", ["require", "jquery", "./defaults", "./utils"], function(t, e, n, i) {
                function o(e, o) {
                    if (this.options = e, null != o && this.fromElement(o), this.options = n.apply(this.options), o && o.is("input")) {
                        var s = t(this.get("amdBase") + "compat/inputData");
                        this.options.dataAdapter = i.Decorate(this.options.dataAdapter, s)
                    }
                }
                return o.prototype.fromElement = function(t) {
                    var n = ["select2"];
                    null == this.options.multiple && (this.options.multiple = t.prop("multiple")), null == this.options.disabled && (this.options.disabled = t.prop("disabled")), null == this.options.language && (t.prop("lang") ? this.options.language = t.prop("lang").toLowerCase() : t.closest("[lang]").prop("lang") && (this.options.language = t.closest("[lang]").prop("lang"))), null == this.options.dir && (t.prop("dir") ? this.options.dir = t.prop("dir") : t.closest("[dir]").prop("dir") ? this.options.dir = t.closest("[dir]").prop("dir") : this.options.dir = "ltr"), t.prop("disabled", this.options.disabled), t.prop("multiple", this.options.multiple), t.data("select2Tags") && (this.options.debug && window.console && console.warn && console.warn('Select2: The `data-select2-tags` attribute has been changed to use the `data-data` and `data-tags="true"` attributes and will be removed in future versions of Select2.'), t.data("data", t.data("select2Tags")), t.data("tags", !0)), t.data("ajaxUrl") && (this.options.debug && window.console && console.warn && console.warn("Select2: The `data-ajax-url` attribute has been changed to `data-ajax--url` and support for the old attribute will be removed in future versions of Select2."), t.attr("ajax--url", t.data("ajaxUrl")), t.data("ajax--url", t.data("ajaxUrl")));
                    var o = {};
                    o = e.fn.jquery && "1." == e.fn.jquery.substr(0, 2) && t[0].dataset ? e.extend(!0, {}, t[0].dataset, t.data()) : t.data();
                    var s = e.extend(!0, {}, o);
                    s = i._convertData(s);
                    for (var r in s) e.inArray(r, n) > -1 || (e.isPlainObject(this.options[r]) ? e.extend(this.options[r], s[r]) : this.options[r] = s[r]);
                    return this
                }, o.prototype.get = function(t) {
                    return this.options[t]
                }, o.prototype.set = function(t, e) {
                    this.options[t] = e
                }, o
            }), e.define("select2/core", ["jquery", "./options", "./utils", "./keys"], function(t, e, n, i) {
                var o = function(t, n) {
                    null != t.data("select2") && t.data("select2").destroy(), this.$element = t, this.id = this._generateId(t), n = n || {}, this.options = new e(n, t), o.__super__.constructor.call(this);
                    var i = t.attr("tabindex") || 0;
                    t.data("old-tabindex", i), t.attr("tabindex", "-1");
                    var s = this.options.get("dataAdapter");
                    this.dataAdapter = new s(t, this.options);
                    var r = this.render();
                    this._placeContainer(r);
                    var a = this.options.get("selectionAdapter");
                    this.selection = new a(t, this.options), this.$selection = this.selection.render(), this.selection.position(this.$selection, r);
                    var l = this.options.get("dropdownAdapter");
                    this.dropdown = new l(t, this.options), this.$dropdown = this.dropdown.render(), this.dropdown.position(this.$dropdown, r);
                    var c = this.options.get("resultsAdapter");
                    this.results = new c(t, this.options, this.dataAdapter), this.$results = this.results.render(), this.results.position(this.$results, this.$dropdown);
                    var d = this;
                    this._bindAdapters(), this._registerDomEvents(), this._registerDataEvents(), this._registerSelectionEvents(), this._registerDropdownEvents(), this._registerResultsEvents(), this._registerEvents(), this.dataAdapter.current(function(t) {
                        d.trigger("selection:update", {
                            data: t
                        })
                    }), t.addClass("select2-hidden-accessible"), t.attr("aria-hidden", "true"), this._syncAttributes(), t.data("select2", this)
                };
                return n.Extend(o, n.Observable), o.prototype._generateId = function(t) {
                    var e = "";
                    return e = null != t.attr("id") ? t.attr("id") : null != t.attr("name") ? t.attr("name") + "-" + n.generateChars(2) : n.generateChars(4), e = e.replace(/(:|\.|\[|\]|,)/g, ""), e = "select2-" + e
                }, o.prototype._placeContainer = function(t) {
                    t.insertAfter(this.$element);
                    var e = this._resolveWidth(this.$element, this.options.get("width"));
                    null != e && t.css("width", e)
                }, o.prototype._resolveWidth = function(t, e) {
                    if ("resolve" == e) {
                        var n = this._resolveWidth(t, "style");
                        return null != n ? n : this._resolveWidth(t, "element")
                    }
                    if ("element" == e) {
                        var i = t.outerWidth(!1);
                        return i <= 0 ? "auto" : i + "px"
                    }
                    if ("style" == e) {
                        var o = t.attr("style");
                        if ("string" != typeof o) return null;
                        for (var s = o.split(";"), r = 0, a = s.length; r < a; r += 1) {
                            var l = s[r].replace(/\s/g, ""),
                                c = l.match(/^width:(([-+]?([0-9]*\.)?[0-9]+)(px|em|ex|%|in|cm|mm|pt|pc))/i);
                            if (null !== c && c.length >= 1) return c[1]
                        }
                        return null
                    }
                    return e
                }, o.prototype._bindAdapters = function() {
                    this.dataAdapter.bind(this, this.$container), this.selection.bind(this, this.$container), this.dropdown.bind(this, this.$container), this.results.bind(this, this.$container)
                }, o.prototype._registerDomEvents = function() {
                    var e = this;
                    this.$element.on("change.select2", function() {
                        e.dataAdapter.current(function(t) {
                            e.trigger("selection:update", {
                                data: t
                            })
                        })
                    }), this.$element.on("focus.select2", function(t) {
                        e.trigger("focus", t)
                    }), this._syncA = n.bind(this._syncAttributes, this), this._syncS = n.bind(this._syncSubtree, this), this.$element[0].attachEvent && this.$element[0].attachEvent("onpropertychange", this._syncA);
                    var i = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
                    null != i ? (this._observer = new i(function(n) {
                        t.each(n, e._syncA), t.each(n, e._syncS)
                    }), this._observer.observe(this.$element[0], {
                        attributes: !0,
                        childList: !0,
                        subtree: !1
                    })) : this.$element[0].addEventListener && (this.$element[0].addEventListener("DOMAttrModified", e._syncA, !1), this.$element[0].addEventListener("DOMNodeInserted", e._syncS, !1), this.$element[0].addEventListener("DOMNodeRemoved", e._syncS, !1))
                }, o.prototype._registerDataEvents = function() {
                    var t = this;
                    this.dataAdapter.on("*", function(e, n) {
                        t.trigger(e, n)
                    })
                }, o.prototype._registerSelectionEvents = function() {
                    var e = this,
                        n = ["toggle", "focus"];
                    this.selection.on("toggle", function() {
                        e.toggleDropdown()
                    }), this.selection.on("focus", function(t) {
                        e.focus(t)
                    }), this.selection.on("*", function(i, o) {
                        -1 === t.inArray(i, n) && e.trigger(i, o)
                    })
                }, o.prototype._registerDropdownEvents = function() {
                    var t = this;
                    this.dropdown.on("*", function(e, n) {
                        t.trigger(e, n)
                    })
                }, o.prototype._registerResultsEvents = function() {
                    var t = this;
                    this.results.on("*", function(e, n) {
                        t.trigger(e, n)
                    })
                }, o.prototype._registerEvents = function() {
                    var t = this;
                    this.on("open", function() {
                        t.$container.addClass("select2-container--open")
                    }), this.on("close", function() {
                        t.$container.removeClass("select2-container--open")
                    }), this.on("enable", function() {
                        t.$container.removeClass("select2-container--disabled")
                    }), this.on("disable", function() {
                        t.$container.addClass("select2-container--disabled")
                    }), this.on("blur", function() {
                        t.$container.removeClass("select2-container--focus")
                    }), this.on("query", function(e) {
                        t.isOpen() || t.trigger("open", {}), this.dataAdapter.query(e, function(n) {
                            t.trigger("results:all", {
                                data: n,
                                query: e
                            })
                        })
                    }), this.on("query:append", function(e) {
                        this.dataAdapter.query(e, function(n) {
                            t.trigger("results:append", {
                                data: n,
                                query: e
                            })
                        })
                    }), this.on("keypress", function(e) {
                        var n = e.which;
                        t.isOpen() ? n === i.ESC || n === i.TAB || n === i.UP && e.altKey ? (t.close(), e.preventDefault()) : n === i.ENTER ? (t.trigger("results:select", {}), e.preventDefault()) : n === i.SPACE && e.ctrlKey ? (t.trigger("results:toggle", {}), e.preventDefault()) : n === i.UP ? (t.trigger("results:previous", {}), e.preventDefault()) : n === i.DOWN && (t.trigger("results:next", {}), e.preventDefault()) : (n === i.ENTER || n === i.SPACE || n === i.DOWN && e.altKey) && (t.open(), e.preventDefault())
                    })
                }, o.prototype._syncAttributes = function() {
                    this.options.set("disabled", this.$element.prop("disabled")), this.options.get("disabled") ? (this.isOpen() && this.close(), this.trigger("disable", {})) : this.trigger("enable", {})
                }, o.prototype._syncSubtree = function(t, e) {
                    var n = !1,
                        i = this;
                    if (!t || !t.target || "OPTION" === t.target.nodeName || "OPTGROUP" === t.target.nodeName) {
                        if (e)
                            if (e.addedNodes && e.addedNodes.length > 0)
                                for (var o = 0; o < e.addedNodes.length; o++) {
                                    var s = e.addedNodes[o];
                                    s.selected && (n = !0)
                                } else e.removedNodes && e.removedNodes.length > 0 && (n = !0);
                            else n = !0;
                        n && this.dataAdapter.current(function(t) {
                            i.trigger("selection:update", {
                                data: t
                            })
                        })
                    }
                }, o.prototype.trigger = function(t, e) {
                    var n = o.__super__.trigger,
                        i = {
                            open: "opening",
                            close: "closing",
                            select: "selecting",
                            unselect: "unselecting"
                        };
                    if (void 0 === e && (e = {}), t in i) {
                        var s = i[t],
                            r = {
                                prevented: !1,
                                name: t,
                                args: e
                            };
                        if (n.call(this, s, r), r.prevented) return void(e.prevented = !0)
                    }
                    n.call(this, t, e)
                }, o.prototype.toggleDropdown = function() {
                    this.options.get("disabled") || (this.isOpen() ? this.close() : this.open())
                }, o.prototype.open = function() {
                    this.isOpen() || this.trigger("query", {})
                }, o.prototype.close = function() {
                    this.isOpen() && this.trigger("close", {})
                }, o.prototype.isOpen = function() {
                    return this.$container.hasClass("select2-container--open")
                }, o.prototype.hasFocus = function() {
                    return this.$container.hasClass("select2-container--focus")
                }, o.prototype.focus = function(t) {
                    this.hasFocus() || (this.$container.addClass("select2-container--focus"), this.trigger("focus", {}))
                }, o.prototype.enable = function(t) {
                    this.options.get("debug") && window.console && console.warn && console.warn('Select2: The `select2("enable")` method has been deprecated and will be removed in later Select2 versions. Use $element.prop("disabled") instead.'), null != t && 0 !== t.length || (t = [!0]);
                    var e = !t[0];
                    this.$element.prop("disabled", e)
                }, o.prototype.data = function() {
                    this.options.get("debug") && arguments.length > 0 && window.console && console.warn && console.warn('Select2: Data can no longer be set using `select2("data")`. You should consider setting the value instead using `$element.val()`.');
                    var t = [];
                    return this.dataAdapter.current(function(e) {
                        t = e
                    }), t
                }, o.prototype.val = function(e) {
                    if (this.options.get("debug") && window.console && console.warn && console.warn('Select2: The `select2("val")` method has been deprecated and will be removed in later Select2 versions. Use $element.val() instead.'), null == e || 0 === e.length) return this.$element.val();
                    var n = e[0];
                    t.isArray(n) && (n = t.map(n, function(t) {
                        return t.toString()
                    })), this.$element.val(n).trigger("change")
                }, o.prototype.destroy = function() {
                    this.$container.remove(), this.$element[0].detachEvent && this.$element[0].detachEvent("onpropertychange", this._syncA), null != this._observer ? (this._observer.disconnect(), this._observer = null) : this.$element[0].removeEventListener && (this.$element[0].removeEventListener("DOMAttrModified", this._syncA, !1), this.$element[0].removeEventListener("DOMNodeInserted", this._syncS, !1), this.$element[0].removeEventListener("DOMNodeRemoved", this._syncS, !1)), this._syncA = null, this._syncS = null, this.$element.off(".select2"), this.$element.attr("tabindex", this.$element.data("old-tabindex")), this.$element.removeClass("select2-hidden-accessible"), this.$element.attr("aria-hidden", "false"), this.$element.removeData("select2"), this.dataAdapter.destroy(), this.selection.destroy(), this.dropdown.destroy(), this.results.destroy(), this.dataAdapter = null, this.selection = null, this.dropdown = null, this.results = null
                }, o.prototype.render = function() {
                    var e = t('<span class="select2 select2-container"><span class="selection"></span><span class="dropdown-wrapper" aria-hidden="true"></span></span>');
                    return e.attr("dir", this.options.get("dir")), this.$container = e, this.$container.addClass("select2-container--" + this.options.get("theme")), e.data("element", this.$element), e
                }, o
            }), e.define("jquery-mousewheel", ["jquery"], function(t) {
                return t
            }), e.define("jquery.select2", ["jquery", "jquery-mousewheel", "./select2/core", "./select2/defaults"], function(t, e, n, i) {
                if (null == t.fn.select2) {
                    var o = ["open", "close", "destroy"];
                    t.fn.select2 = function(e) {
                        if ("object" == typeof(e = e || {})) return this.each(function() {
                            var i = t.extend(!0, {}, e);
                            new n(t(this), i)
                        }), this;
                        if ("string" == typeof e) {
                            var i, s = Array.prototype.slice.call(arguments, 1);
                            return this.each(function() {
                                var n = t(this).data("select2");
                                null == n && window.console && console.error && console.error("The select2('" + e + "') method was called on an element that is not using Select2."), i = n[e].apply(n, s)
                            }), t.inArray(e, o) > -1 ? this : i
                        }
                        throw new Error("Invalid arguments for Select2: " + e)
                    }
                }
                return null == t.fn.select2.defaults && (t.fn.select2.defaults = i), n
            }), {
                define: e.define,
                require: e.require
            }
        }(),
        n = e.require("jquery.select2");
    return t.fn.select2.amd = e, n
});

$(".box-filter input[type='radio']").on("click", function(e) {
    $("input[name='" + $(this).attr("name") + "']:radio").not(this).removeData("chk");
    $(this).data("chk", !$(this).data("chk"));
    $(this).prop("checked", $(this).data("chk"))
});
$(".apply-filter").click(function() {
    var col = $(".box-filter").data("collection");
    var url_search = "/collections/" + col + "/";
    if ($("#cat_item_1").find("input:checked").val()) url_search += $("#cat_item_1").find("input:checked").val() + "+";
    if ($("#cat_item_2").find("input:checked").val()) url_search += $("#cat_item_2").find("input:checked").val() + "+";
    if ($("#cat_item_3").find("input:checked").val()) url_search += $("#cat_item_3").find("input:checked").val() + "+";
    if ($("#cat_item_4").find("input:checked").val()) url_search += $("#cat_item_4").find("input:checked").val() + "+";
    if ($("#cat_item_5").find("input:checked").val()) url_search += $("#cat_item_5").find("input:checked").val() + "+";
    if ($("#cat_item_6").find("input:checked").val()) url_search += $("#cat_item_6").find("input:checked").val() + "+";
    if ($("#cat_item_7").find("input:checked").val()) url_search += $("#cat_item_7").find("input:checked").val() + "+";
    if ($("#cat_item_8").find("input:checked").val()) url_search += $("#cat_item_8").find("input:checked").val() + "+";
    if ($("#cat_item_9").find("input:checked").val()) url_search += $("#cat_item_9").find("input:checked").val() + "+";
    if ($("#cat_item_10").find("input:checked").val()) url_search += $("#cat_item_10").find("input:checked").val() + "+";
    if ($("#cat_item_11").find("input:checked").val()) url_search += $("#cat_item_11").find("input:checked").val() + "+";
    if ($("#cat_item_12").find("input:checked").val()) url_search += $("#cat_item_12").find("input:checked").val() + "+";
    if ($("#cat_item_13").find("input:checked").val()) url_search += $("#cat_item_13").find("input:checked").val() + "+";
    if ($("#cat_item_14").find("input:checked").val()) url_search += $("#cat_item_14").find("input:checked").val() + "+";
    if ($("#cat_item_15").find("input:checked").val()) url_search += $("#cat_item_15").find("input:checked").val() + "+";
    if ($("#cat_item_16").find("input:checked").val()) url_search += $("#cat_item_16").find("input:checked").val() + "+";
    if ($("#cat_item_17").find("input:checked").val()) url_search += $("#cat_item_17").find("input:checked").val() + "+";
    if ($("#cat_item_18").find("input:checked").val()) url_search += $("#cat_item_18").find("input:checked").val() + "+";
    if ($("#cat_item_19").find("input:checked").val()) url_search += $("#cat_item_19").find("input:checked").val() + "+";
    if ($("#cat_item_20").find("input:checked").val()) url_search += $("#cat_item_20").find("input:checked").val() + "+";
    if ($("#cat_item_21").find("input:checked").val()) url_search += $("#cat_item_21").find("input:checked").val() + "+";
    $(location).attr('href', url_search + '?view=')
});

$(".reset-filter").click(function() {
    var col = $(".box-filter").data("collection");
    var url_search = "/collections/" + col + "/";
    $(location).attr('href', url_search)
});
$(".show-more-desc a").click(function() {
    if ($(".case-desc").hasClass("show-more-height")) {
        $('.show-more-desc').addClass('relative')
    } else {
        $('.show-more-desc').removeClass('relative')
    }
    $('html, body').animate({
        scrollTop: $("#specification").offset().top
    }, 500);
    $(".case-desc").toggleClass("show-more-height")
});
$('#link-write-review').click(function() {
    $('.case-ratting').toggleClass('show-more-height2')
});
$('#link-write-questionsx').click(function() {
    $('.case-quest').toggleClass('show-more-height2')
});
$(".show-more-rat a").click(function(e) {
    e.preventDefault();
    if ($(".case-ratting").hasClass("show-more-height")) {
        $('.show-more-rat').addClass('relative');
        $('.template-product #shopify-product-reviews .spr-review').show()
    } else {
        $('.show-more-rat').removeClass('relative')
    }
    $('html, body').animate({
        scrollTop: $("#link-write-review").offset().top
    }, 500);
    $(".case-ratting").toggleClass("show-more-height")
});
$("#link-write-review").click(function() {
    $(".case-ratting").toggleClass('show-more-height');
    $('.show-more-rat').toggleClass('relative')
});
$('#product-fixed .btn').click(function() {
    $('html, body').animate({
        scrollTop: $("#product-anchor").offset().top
    }, 500)
    $('#AddToCart').trigger('click');
});
$("#fixed-product").stick_in_parent({
    offset_top: 50,
    parent: $("#product-bottom")
});
$(".form-flower #button-action .btn").click(function(e) {
    e.preventDefault();
    if ($(window).width() > 768) { /*alert("Silakan lengkapi data terlebih dahulu");*/
        $('html, body').animate({
            scrollTop: $("#product-anchor").offset().top
        }, 500);
        $("#button-action").hide()
    }
    if ($(window).width() < 769) {
        $("#flower-step").addClass("block")
    }
});
$(".customize-papan input[type='file']").change(function() {
    if ($(this).val() !== "") {
        $(this).addClass('sel');
        $(".btn-upload-papan").addClass('uploaded')
    }
});
$(".btn-upload-papan").click(function() {
    $(".customize-papan input[type='file']").click()
});
$(".add-rating-anchor").click(function() {
    $('html, body').animate({
        scrollTop: $("#anchor-review").offset().top
    }, 500)
});
$(".add-question-anchor").click(function() {
    $('html, body').animate({
        scrollTop: $("#anchor-qna").offset().top
    }, 500)
});
$("#collectionFiltersDesktop").stick_in_parent({
    offset_top: 50,
    parent: $("#collection-product")
});
$("#side-subpage").stick_in_parent({
    offset_top: 50,
    parent: $("#page-side")
});
$(document).ready(function() {
    $('.header_cart__ins a').hover(function() {
        $('header_cart__ins a img.icon_cart_active').hide()
    });
    $(".variant-button li").click(function() {
        var idx = jQuery(this).attr('data-idx');
        jQuery(".select-variant").val(idx).trigger("change")
    })
})

$(document).ready(function() {
    $("select").addClass("needsclick");
    FastClick.attach(document.body);
    var $customSelects = $('.select-search');
    $customSelects.select2({
        templateResult: function(result, container) {
            if (!result.id) {
                return result.text;
            }
            container.className += ' needsclick';
            return result.text;
        },
        sorter: function(data) {
            /* Sort data using lowercase comparison */
            return data.sort(function(a, b) {
                a = a.text.toLowerCase();
                b = b.text.toLowerCase();
                if (a > b) {
                    return 1;
                } else if (a < b) {
                    return -1;
                }
                return 0;
            });
        }
    });
    $customSelects.each(function(index, el) {
        $(el).data('select2').$container.find('*').addClass('needsclick');
    });
});
$(function() {
    $('.col-wrap .cats .cat').addClass('dontsplit');
    if (!$('.col-left').is('.columned')) {
        $('.col-left .cats').columnize({
            columns: 2,
            buildOnce: true
        });
        $('.col-left').addClass('columned');
    }
});

$(document).ready(function() {
    var s = $(".header-wrapper");
    var pos = s.position();
    $(window).scroll(function() {
        var windowpos = $(window).scrollTop();
        if (windowpos > pos.top) {
            s.addClass("stick");
            $("body").addClass("header-fixed");
        } else {
            s.removeClass("stick");
            $("body").removeClass("header-fixed");
        }
    });
});
$(".lazyload").lazyload();